import React, { Component } from "react";
import CartContext from "./CartContext";
import { BiRefresh } from "react-icons/bi";
import { MessageBox } from "./MessageBox";
import { LoadSpinner } from "./LoadSpinner";
import Select from "react-select";
import { Link } from "react-router-dom";
import { BlobServiceClient } from "@azure/storage-blob";
import Swal from "sweetalert2";
import Fuse from "fuse.js";
import {
  OverlayTrigger,
  ButtonGroup,
  Accordion,
  FloatingLabel,
  Stack,
  Tooltip,
  Badge,
  Button,
  ButtonToolbar,
  Form,
  FormControl,
  Row,
  Col,
  Modal,
  Nav,
  Tabs,
  Tab,
  Table,
  Navbar,
} from "react-bootstrap";

/* ----------------- small util ----------------- */
const asNumber = (v, fallback = 0) => {
  const n = Number(v);
  return Number.isFinite(n) ? n : fallback;
};

/* ==================== ProductInward (Main) ==================== */
export class ProductInward extends Component {
  static contextType = CartContext;
  constructor(props) {
    super(props);
    this.state = {
      purchaseOrders: [],
      warehouse: [],
      suppliers: [],
      prods: [],
      loaded: false,
      addModalShow: false,
      key: "UnPaidOrders",
      msgboxOpen: false,
      msgboxTitle: "",
      msgboxMessage: "",
      showAnalytics: false,
      loadSpinnerOpen: false,
    };
    this._keyListener = this._keyListener.bind(this);
  }
  ShowLoadSpinner = () => this.setState({ loadSpinnerOpen: true });
  HideLoadSpinner = () => this.setState({ loadSpinnerOpen: false });
  componentDidMount() {
    if (!this.state.loaded) {
      this.GetPurchaseOrders();
      this.GetSuppliers();
      this.GetInventories();
      this.GetWarehouses();
      this.setState({ loaded: true });
    }
    window.scrollTo(0, 0);
    document.addEventListener("keydown", this._keyListener);
  }
  componentWillUnmount() {
    document.removeEventListener("keydown", this._keyListener);
  }
  _keyListener(e) {
    if (e.key === "F8") this.setState({ addModalShow: true });
    else if (e.key === "F9") this.OnRefreshButtonClick();
  }

  GetInventories = () => {
    fetch(
      `${process.env.REACT_APP_API}Product/GetProducts/${this.context.storeId}`
    )
      .then((r) => r.json())
      .then((data) => this.setState({ prods: data || [] }))
      .catch((err) => console.error("GetInventories", err));
  };

  GetSuppliers = () => {
    fetch(
      `${process.env.REACT_APP_API}Supplier/GetSuppliers/${this.context.storeId}`
    )
      .then((r) => r.json())
      .then((data) => this.setState({ suppliers: data || [] }))
      .catch((err) => console.error("GetSuppliers", err));
  };

  GetWarehouses = () => {
    fetch(
      process.env.REACT_APP_API +
        "Warehouse/GetRawMaterialWarehouses/" +
        this.context.storeId
    )
      .then((response) => response.json())
      .then((data) => {
        if (data.status == 400) {
        } else {
          this.setState({ warehouse: data }, () => {
            this.setState({ reload: false }, () => {
              this.setState({ reload: true });
            });
          });
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  };

  GetPurchaseOrders = () => {
    this.ShowLoadSpinner();
    fetch(
      `${process.env.REACT_APP_API}ProductPurchase/GetPurchaseOrders/${this.context.storeId}`
    )
      .then((r) => r.json())
      .then((data) => {
        this.setState({ purchaseOrders: data || [] });
        this.HideLoadSpinner();
      })
      .catch((err) => {
        this.HideLoadSpinner();
        console.error("GetPurchaseOrders", err);
      });
  };

  CloseMessagBoxCallback = () => this.setState({ msgboxOpen: false });
  ShowMessagBox = (t, m) =>
    this.setState({ msgboxOpen: true, msgboxTitle: t, msgboxMessage: m });
  OnRefreshButtonClick = () => this.GetPurchaseOrders();

  render() {
    const orders = this.state.purchaseOrders || [];
    return (
      <>
        <div className="Container-fluid p-0">
          {this.state.msgboxOpen && (
            <MessageBox
              open={this.state.msgboxOpen}
              title={this.state.msgboxTitle}
              message={this.state.msgboxMessage}
              callback={this.CloseMessagBoxCallback}
            />
          )}
          {this.state.loadSpinnerOpen && <LoadSpinner open />}
          <Navbar className="shadow position-sticky fixed-top py-3 text-black">
            <h4>Product Purchased INWARD&nbsp;</h4>
            <Navbar.Collapse className="justify-content-end mx-0">
              <Nav>
                <ButtonToolbar className="text-end align-middle">
                  <Button
                    size="sm"
                    className="mainthemecolor"
                    onClick={() => this.setState({ addModalShow: true })}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="currentColor"
                      className="bi bi-plus"
                      viewBox="0 0 16 16"
                    >
                      <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z" />
                    </svg>
                    &nbsp;Add (F8)
                  </Button>
                  &nbsp;
                  <Button
                    className="mainthemecolor"
                    size="sm"
                    onClick={this.OnRefreshButtonClick}
                  >
                    <BiRefresh size={16} /> &nbsp;Refresh (F9)
                  </Button>
                  &nbsp;
                </ButtonToolbar>
              </Nav>
            </Navbar.Collapse>
          </Navbar>

          <div className="purposestyle p-2">
            <b>Purpose:</b> Use this module to enter purchased product items
            from suppliers. Stocks will be updated when you save a purchase.
          </div>

          {orders.length > 0 && (
            <Tabs
              id="product-purchase-tabs"
              activeKey={this.state.key}
              onSelect={(k) => this.setState({ key: k })}
              className="mb-3 bg-light fw-bold"
              fill
              style={{ fontSize: "16px" }}
            >
              <Tab
                eventKey="UnPaidOrders"
                title={`1. Unpaid Orders (${
                  orders.filter((f) => Number(f.paymentStatusId) === 2).length
                })`}
              >
                <ProductPurchaseOrdersTable
                  status={2}
                  OnDeleted={() => this.OnRefreshButtonClick()}
                  suppliers={this.state.suppliers}
                  purchaseOrders={orders}
                  prods={this.state.prods}
                  refresh={this.OnRefreshButtonClick}
                  warehouse={this.state.warehouse}
                />
              </Tab>
              <Tab
                eventKey="PartiallyPaidOrders"
                title={`2. Partially Paid Orders (${
                  orders.filter((f) => Number(f.paymentStatusId) === 3).length
                })`}
              >
                <ProductPurchaseOrdersTable
                  status={3}
                  OnDeleted={() => this.OnRefreshButtonClick()}
                  suppliers={this.state.suppliers}
                  purchaseOrders={orders}
                  prods={this.state.prods}
                  refresh={this.OnRefreshButtonClick}
                  warehouse={this.state.warehouse}
                />
              </Tab>
              <Tab
                eventKey="PaidOrders"
                title={`3. Paid Orders (${
                  orders.filter((f) => Number(f.paymentStatusId) === 1).length
                })`}
              >
                <ProductPurchaseOrdersTable
                  status={1}
                  OnDeleted={() => this.OnRefreshButtonClick()}
                  suppliers={this.state.suppliers}
                  purchaseOrders={orders}
                  prods={this.state.prods}
                  refresh={this.OnRefreshButtonClick}
                  warehouse={this.state.warehouse}
                />
              </Tab>
            </Tabs>
          )}

          {this.state.addModalShow && (
            <ProductPurchaseOrderAddOrEditModal
              show={this.state.addModalShow}
              Type="Add"
              onHide={() =>
                this.setState(
                  { addModalShow: false },
                  this.OnRefreshButtonClick
                )
              }
              suppliers={this.state.suppliers}
              prods={this.state.prods}
              warehouse={this.state.warehouse}
              refresh={this.OnRefreshButtonClick}
            />
          )}
        </div>
      </>
    );
  }
}

/* ==================== ProductPurchaseOrdersTable ==================== */
export class ProductPurchaseOrdersTable extends Component {
  static contextType = CartContext;
  constructor(props) {
    super(props);
    this.state = {
      filtered: props.purchaseOrders || [],
      editModalShow: false,
      editPO: null,
      loadSpinnerOpen: false,
      selectedPO: null,
    };
    this.inputFile = React.createRef();
  }

  componentDidMount() {
    this.setState({ filtered: this.props.purchaseOrders || [] });
  }

  componentDidUpdate(prevProps) {
    if (prevProps.purchaseOrders !== this.props.purchaseOrders) {
      this.setState({ filtered: this.props.purchaseOrders || [] });
    }
  }

  ShowLoadSpinner = () => this.setState({ loadSpinnerOpen: true });
  HideLoadSpinner = () => this.setState({ loadSpinnerOpen: false });

  onUploadButtonClick = (po) => {
    this.setState({ selectedPO: po }, () => this.inputFile.current?.click());
  };

  handleFileUpload = async (e) => {
    const files = e.target.files;
    if (!files || files.length === 0) return;
    const po = this.state.selectedPO;
    if (!po || !po.id) {
      Swal.fire("Error", "No Purchase Order selected for upload.", "error");
      e.target.value = null;
      return;
    }
    this.ShowLoadSpinner();
    try {
      const file = files[0];
      const extension = file.name.split(".").pop();
      const targetFileName = `${po.id}.${extension}`;

      const blobService = new BlobServiceClient(
        `${this.context.store.storageBlobUrl}${this.context.store.storageSasToken}`
      );
      const containerClient = blobService.getContainerClient(
        this.context.store.storageBlobContainerName
      );
      const blobClient = containerClient.getBlockBlobClient(
        `po-orders/${targetFileName}`
      );

      await blobClient.uploadData(file, {
        blobHTTPHeaders: { blobContentType: file.type },
      });

      const res = await fetch(
        `${process.env.REACT_APP_API}ProductPurchase/UpdateProductPurchaseAttachmentFileName/`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            id: po.id,
            attachmentFileName: targetFileName,
          }),
        }
      );
      if (!res.ok) throw new Error(`Server returned ${res.status}`);

      Swal.fire("Success", "Attachment uploaded.", "success");
      this.props.refresh && this.props.refresh();
    } catch (err) {
      console.error("Upload failed", err);
      Swal.fire("Error", "File upload failed. Try again.", "error");
    } finally {
      this.HideLoadSpinner();
      e.target.value = null;
      this.setState({ selectedPO: null });
    }
  };

  deleteBlobInContainer = async (po) => {
    if (!po?.attachmentFileName) {
      Swal.fire("Info", "No attachment to delete.", "info");
      return;
    }
    const confirm = await Swal.fire({
      title: "Confirm",
      text: "Delete attachment for this PO?",
      icon: "warning",
      showCancelButton: true,
    });
    if (!confirm.isConfirmed) return;
    this.ShowLoadSpinner();
    try {
      const blobService = new BlobServiceClient(
        `${this.context.store.storageBlobUrl}${this.context.store.storageSasToken}`
      );
      const containerClient = blobService.getContainerClient(
        this.context.store.storageBlobContainerName
      );
      const blobClient = containerClient.getBlockBlobClient(
        `po-orders/${po.attachmentFileName}`
      );
      await blobClient.deleteIfExists({ deleteSnapshots: "include" });

      const res = await fetch(
        `${process.env.REACT_APP_API}ProductPurchase/UpdateProductPurchaseAttachmentFileName/`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ id: po.id, attachmentFileName: "" }),
        }
      );
      if (!res.ok) throw new Error(`Server returned ${res.status}`);

      Swal.fire("Deleted", "Attachment removed.", "success");
      this.props.refresh && this.props.refresh();
    } catch (err) {
      console.error("Delete failed", err);
      Swal.fire("Error", "Failed to delete attachment.", "error");
    } finally {
      this.HideLoadSpinner();
    }
  };

  onDelete = async (po, e) => {
    if (e?.stopPropagation) e.stopPropagation();
    if (!po?.id) {
      Swal.fire("Information", "Invalid row. Refresh and try again.", "info");
      return;
    }
    const confirm = await Swal.fire({
      title: "Warning!",
      text: "This action will delete associated details as well. Proceed?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes",
    });
    if (!confirm.isConfirmed) return;
    try {
      const res = await fetch(
        `${process.env.REACT_APP_API}ProductPurchase/DeletePurchaseOrder/${po.id}`,
        {
          method: "DELETE",
          headers: { "Content-Type": "application/json" },
        }
      );
      if (!res.ok) {
        Swal.fire(
          "Not deleted",
          "This Purchase Order may be associated with other records.",
          "error"
        );
        return;
      }
      Swal.fire("Deleted", "Purchase Order deleted successfully", "success");
      this.props.OnDeleted && this.props.OnDeleted();
    } catch (err) {
      Swal.fire("Error", "Delete failed: " + String(err), "error");
    }
  };

  onOpenEdit = (po, e) => {
    if (e?.stopPropagation) e.stopPropagation();
    this.setState({ editModalShow: true, editPO: po });
  };

  onSearchChange = (query) => {
    if (!query) {
      this.setState({ filtered: this.props.purchaseOrders || [] });
      return;
    }
    const fuse = new Fuse(this.props.purchaseOrders || [], {
      keys: ["invoiceNo", "purchaseOrderNo"],
      threshold: 0.3,
      ignoreLocation: true,
      distance: 120,
    });
    const res = fuse.search(query).map((r) => r.item);
    this.setState({ filtered: res.slice(0, 200) });
  };

  getTotalPaid = (po) => {
    const payments = po?.produtPurchasePayments || [];
    return (payments || []).reduce((s, p) => s + (Number(p.amount) || 0), 0);
  };

  getPurchaseTotal = (po) => {
    const items = po.purchaseOrderItems || [];
    let subtotal = 0,
      tax = 0;
    items.forEach((v) => {
      const rate = Number(v.rate) || 0;
      const qty = Number(v.qty) || 0;
      const discount = Number(v.discount) || 0;
      const itemTax = Number(v.tax) || 0;
      const stotal = rate * qty - (rate * qty * discount) / 100;
      subtotal += stotal;
      tax += (stotal * itemTax) / 100;
    });
    const poTaxPct = Number(po.taxPercentage) || 0;
    const purchaseTax = (subtotal * poTaxPct) / 100;
    const loading = Number(po.loadingCharges) || 0;
    const transport = Number(po.transportationCharges) || 0;
    return subtotal + tax + purchaseTax + loading + transport;
  };

  GetWarehouseName = (id) => {
    const wh = (this.props.warehouse || []).find(
      (w) => String(w.id) === String(id)
    );
    return wh ? wh.name : "";
  };

  renderHeader = (po) => {
    const invoiceNo = po.invoiceNo || "-";
    const dateStr = po.invoiceDate
      ? this.context.GetInDateFormat(new Date(po.invoiceDate))
      : "-";
    const supplier = (this.props.suppliers || []).find(
      (s) => String(s.id) === String(po.supplierId)
    )?.name;
    const total = this.getPurchaseTotal(po);
    const paid = this.getTotalPaid(po);

    return (
      <div
        className="d-flex w-100 align-items-center justify-content-between flex-wrap gap-2"
        style={{ fontSize: "0.9rem" }}
      >
        <div className="d-flex align-items-center gap-3">
          <div className="fw-semibold">{dateStr}</div>
          <div className="text-muted">Inv: {invoiceNo}</div>
          <Badge bg="secondary">
            {Number(po.paymentStatusId) === 1
              ? "Paid"
              : Number(po.paymentStatusId) === 2
              ? "Unpaid"
              : Number(po.paymentStatusId) === 3
              ? "Partially Paid"
              : "Unknown"}
          </Badge>
        </div>

        <div className="d-flex align-items-center gap-4 text-muted">
          <small>
            Supplier:&nbsp;
            <span className="text-dark fw-semibold">{supplier || "-"}</span>
          </small>
          <small>
            Total:&nbsp;
            <span className="text-dark fw-semibold">
              {Number(total || 0).toLocaleString(
                this.context.storeSettings?.defaultLocale || "en-IN",
                {
                  style: "currency",
                  currency:
                    this.context.storeSettings?.defaultCurrency || "INR",
                }
              )}
            </span>
          </small>
          <small>
            Paid:&nbsp;
            <span className="text-dark fw-semibold">
              {Number(paid || 0).toLocaleString(
                this.context.storeSettings?.defaultLocale || "en-IN",
                {
                  style: "currency",
                  currency:
                    this.context.storeSettings?.defaultCurrency || "INR",
                }
              )}
            </span>
          </small>
          <small>
            CreatedBy:&nbsp;
            <span className="text-dark fw-semibold">{po.createdBy || "-"}</span>
          </small>
        </div>

        <div className="d-flex align-items-center gap-3">
          <input
            style={{ display: "none" }}
            accept=".png,.jpg,.jpeg,.pdf"
            ref={this.inputFile}
            onChange={this.handleFileUpload}
            type="file"
          />
          {!po.attachmentFileName ? (
            <small className="text-muted">
              <Link onClick={() => this.onUploadButtonClick(po)}>
                Click to attach
              </Link>
            </small>
          ) : (
            <small className="text-muted d-flex align-items-center gap-2">
              <a
                href={`${this.context.store.storageBlobUrl}${this.context.store.storageBlobContainerName}/po-orders/${po.attachmentFileName}${this.context.store.storageSasToken}`}
                target="_blank"
                rel="noreferrer"
              >
                View Attachment
              </a>
              <Button
                variant="outline-danger"
                size="sm"
                onClick={() => this.deleteBlobInContainer(po)}
              >
                X
              </Button>
            </small>
          )}

          <ButtonGroup size="sm" className="ms-2">
            <OverlayTrigger overlay={<Tooltip>Edit</Tooltip>}>
              <Button
                variant="primary"
                onClick={(e) => this.onOpenEdit(po, e)}
                className="mx-2"
              >
                Open
              </Button>
            </OverlayTrigger>
            <OverlayTrigger
              overlay={
                <Tooltip>Delete (will remove associated details)</Tooltip>
              }
            >
              <Button
                variant="danger"
                className="rounded-circle"
                onClick={(e) => this.onDelete(po, e)}
                disabled={
                  this.context.UserRoles.PRODUCTADMIN !==
                  this.context.userData.roleId
                }
              >
                X
              </Button>
            </OverlayTrigger>
          </ButtonGroup>
        </div>
      </div>
    );
  };

  renderItems = (po) => {
    const items = po.purchaseOrderItems || [];
    if (!items.length) return <div className="text-muted">No items.</div>;

    return (
      <div className="table-responsive">
        <Table hover size="sm" className="mb-2">
          <thead>
            {this.context.store.businessTypeId ===
            this.context.BusinessTypes.STEELTRADERS ? (
              <>
                <tr className="text-center align-middle">
                  <th>#</th>
                  <th className="text-start">Product Name</th>
                  <th>Thickness</th>
                  <th>Width</th>
                  <th>Length</th>
                  <th>BatchId</th>
                  <th>Remarks</th>
                  <th>HSNCode</th>
                  <th>InternalId</th>
                  <th>TestId</th>
                  <th>Pieces</th>
                  <th>Qty/Wt</th>
                  <th>LocalWt</th>
                  <th>P.Rate</th>
                  <th>Unit</th>
                  <th>S.Total</th>
                  <th>Warehouse</th>
                  <th>InStock</th>
                </tr>
              </>
            ) : (
              <>
                <tr className="text-center align-middle">
                  <th>#</th>
                  <th className="text-start">Product Name</th>
                  <th>HSNCode</th>
                  <th>BatchId</th>
                  <th>Qty</th>
                  <th>Purchase Rate/Unit</th>
                  <th>GST %</th>
                  <th>Total Purchase Value(A)</th>
                  <th>Total Tax Value(B) </th>
                  <th>A+B </th>
                  <th>Unit</th>
                  <th>MRP /Unit</th>
                  <th>Warehouse</th>
                  <th>InStock</th>
                </tr>
              </>
            )}
          </thead>
          <tbody>
            {items.map((it, idx) => {
              const rate = Number(it.rate) || 0;
              const qty = Number(it.qty) || 0;
              const subtotal = rate * qty;
              const taxtotal = (subtotal * it.tax) / 100 || 0;
              return (
                <tr key={it.id || idx} className="text-center align-middle">
                  {this.context.store.businessTypeId ===
                  this.context.BusinessTypes.STEELTRADERS ? (
                    <>
                      <td>{idx + 1}</td>
                      <td className="text-start">{it.itemName}</td>
                      <td>{it.thickness}</td>
                      <td>{it.width}</td>
                      <td>{it.length}</td>
                      <td>{it.batchId || ""}</td>
                      <td>{it.remarks || ""}</td>
                      <td>{it.hsnCode || ""}</td>
                      <td>{it.internalId || ""}</td>
                      <td>{it.qualityId || ""}</td>
                      <td>{it.pieces || ""}</td>
                      <td>{it.qty || ""}</td>
                      <td>{it.localWt || ""}</td>
                      <td>{it.rate || ""}</td>
                      <td>{it.unit || ""}</td>
                      <td className="text-end">
                        {subtotal.toLocaleString("en-IN", {
                          style: "currency",
                          currency: "INR",
                        })}
                      </td>
                      {/* <td>{it.categoryName || "-"}</td> */}
                      <td>
                        {it.warehouseName ||
                          this.GetWarehouseName(it.warehouseId)}
                      </td>
                      <td>
                        {it.addedToStock ? (
                          <Badge bg="success">Added</Badge>
                        ) : (
                          <Badge bg="secondary">Pending</Badge>
                        )}
                      </td>
                    </>
                  ) : (
                    <>
                      <td>{idx + 1}</td>
                      <td className="text-start">{it.itemName}</td>
                      <td>{it.hsnCode || ""}</td>
                      <td>{it.batchId || ""}</td>
                      <td>{it.qty || ""}</td>
                      <td>{it.rate || ""}</td>
                      <td>{it.tax || ""}</td>

                      <td className="text-end">
                        {subtotal.toLocaleString("en-IN", {
                          style: "currency",
                          currency: "INR",
                        })}
                      </td>
                      <td className="text-end">
                        {taxtotal.toLocaleString("en-IN", {
                          style: "currency",
                          currency: "INR",
                        })}
                      </td>
                      <td>
                        {(subtotal + taxtotal).toLocaleString("en-IN", {
                          style: "currency",
                          currency: "INR",
                        })}
                      </td>
                      <td>{it.unit || ""}</td>
                      <td>
                        {Number(it?.mrp || 0).toLocaleString("en-IN", {
                          style: "currency",
                          currency: "INR",
                        })}
                      </td>
                      {/* <td>{it.categoryName || "-"}</td> */}
                      <td>
                        {it.warehouseName ||
                          this.GetWarehouseName(it.warehouseId)}
                      </td>
                      <td>
                        {it.addedToStock ? (
                          <Badge bg="success">Added</Badge>
                        ) : (
                          <Badge bg="secondary">Pending</Badge>
                        )}
                      </td>
                    </>
                  )}
                </tr>
              );
            })}
          </tbody>
        </Table>
      </div>
    );
  };

  render() {
    const rows = (this.state.filtered || [])
      .filter((f) => Number(f.paymentStatusId) === Number(this.props.status))
      .sort((a, b) => new Date(a.created) < new Date(b.created));

    return (
      <>
        <Row className="mb-2 mx-3">
          <Col md={12}>
            <Stack direction="horizontal" gap={3}>
              <b>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  className="bi bi-search"
                  viewBox="0 0 16 16"
                >
                  <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1 1 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z" />
                </svg>
              </b>
              <FormControl
                type="search"
                placeholder="Search InvoiceNo / PO Number"
                aria-label="Search by invoice no"
                onChange={(e) => this.onSearchChange(e.target.value)}
              />
            </Stack>
          </Col>
        </Row>

        <div className="mx-4">
          <Accordion alwaysOpen>
            {rows.map((po, idx) => {
              const prId = String(po.id || idx);
              return (
                <Accordion.Item eventKey={prId} key={prId} className="mb-2">
                  <Accordion.Header>{this.renderHeader(po)}</Accordion.Header>
                  <Accordion.Body>{this.renderItems(po)}</Accordion.Body>
                </Accordion.Item>
              );
            })}
          </Accordion>
        </div>

        {this.state.editModalShow && (
          <ProductPurchaseOrderAddOrEditModal
            show={true}
            onHide={() => {
              this.setState({ editModalShow: false, editPO: null });
              this.props.refresh && this.props.refresh();
            }}
            purchaseOrder={this.state.editPO}
            Type="Edit"
            suppliers={this.props.suppliers}
            prods={this.props.prods}
            warehouse={this.props.warehouse}
            refresh={this.props.refresh}
          />
        )}
      </>
    );
  }
}

export class ProductPurchaseOrderAddOrEditModal extends Component {
  static contextType = CartContext;

  constructor(props) {
    super(props);
    this.state = {
      purchaseOrder: {
        id: undefined,
        invoiceDate: new Date(),
        paidAmount: 0,
        taxPercentage: 0,
        loadingCharges: 0,
        transportationCharges: 0,
        invoiceNo: "",
        supplierId: "",
        paymentStatusId: "",
        description: "",
        purchaseOrderNo: "", // <-- add
      },
      msgboxOpen: false,
      msgboxTitle: "",
      msgboxMessage: "",
      loadSpinnerOpen: false,
      PurchaseOrderItems: [],
      ProdutPurchasePayments: [],

      showOrderItemModal: false,
      editPurchaseItemRow: -1,
      editItemModalShow: false,

      showPaymentModal: false,
      editPaymentModalShow: false,
      editPaymentRow: -1,

      purchaseRequests: [],
      selectedPurchaseRequestId: "",
      loadedIndentItems: [],
      categories: [],
    };

    this._keyListener = this._keyListener.bind(this);
  }

  /* -------------------- Utilities -------------------- */
  asNumber = (v) => {
    if (v === null || v === undefined || v === "") return 0;
    const n = Number(v);
    return Number.isNaN(n) ? 0 : n;
  };

  GenerateGuid = () =>
    "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
      var r = (Math.random() * 16) | 0,
        v = c === "x" ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });

  ShowLoadSpinner = () => this.setState({ loadSpinnerOpen: true });
  HideLoadSpinner = () => this.setState({ loadSpinnerOpen: false });

  CloseMessagBoxCallback = () => {
    this.setState({ msgboxOpen: false });
    this.props.onHide?.();
  };
  ShowMessagBox = (title, message) =>
    this.setState({
      msgboxOpen: true,
      msgboxTitle: title,
      msgboxMessage: message,
    });

  _keyListener(e) {
    if (e.key === "F8") this.handleAddItems();
  }

  /* -------------------- Lifecycle -------------------- */
  componentDidMount() {
    document.addEventListener("keydown", this._keyListener);
    this.LoadPurchaseRequests();
    if (this.props.Type === "Edit" && this.props.purchaseOrder?.id) {
      this.GetPurchaseOrderById(this.props.purchaseOrder.id);
    } else {
      // initialize purchaseOrder.invoiceDate to ISO-date for inputs
      this.setState((s) => ({
        purchaseOrder: {
          ...s.purchaseOrder,
          invoiceDate: new Date().toISOString().split("T")[0],
        },
      }));
    }
  }

  componentWillUnmount() {
    document.removeEventListener("keydown", this._keyListener);
  }

  /* -------------------- Load PRs & PO -------------------- */
  LoadPurchaseRequests = () => {
    try {
      const storeId = this.context.storeId;
      if (!storeId) return Promise.resolve([]);

      return fetch(
        `${process.env.REACT_APP_API}ProductPurchase/GetPurchaseRequest/${storeId}`
      )
        .then((r) => r.json())
        .then((data) => {
          const list = Array.isArray(data) ? data : [];
          const normalized = list.map((pr) => ({
            ...pr,
            id: String(pr.id ?? pr.Id ?? ""),
            purchaseOrderNo: pr.purchaseOrderNo ?? pr.PurchaseOrderNo ?? "",
          }));
          console.log(
            "LoadPurchaseRequests -> normalized PR list:",
            normalized
          );
          this.setState({ purchaseRequests: normalized });
          return normalized;
        })
        .catch((err) => {
          console.error("LoadPurchaseRequests error", err);
          this.setState({ purchaseRequests: [] });
          return [];
        });
    } catch (e) {
      console.error("LoadPurchaseRequests exception", e);
      this.setState({ purchaseRequests: [] });
      return Promise.resolve([]);
    }
  };
  GetPurchaseOrderById = (Id) => {
    if (!Id) return;
    this.ShowLoadSpinner();

    // preload PR list (so we can match by PO number quickly)
    const prPromise = this.LoadPurchaseRequests();
    const poPromise = fetch(
      `${process.env.REACT_APP_API}ProductPurchase/GetPurchaseOrderById/${Id}`
    ).then((r) => r.json());

    Promise.all([prPromise, poPromise])
      .then(async ([purchaseRequests, data]) => {
        this.HideLoadSpinner();
        if (!data) {
          console.warn("GetPurchaseOrderById: no data returned for PO id", Id);
          return;
        }

        // normalize items
        const rawItems = Array.isArray(data.purchaseOrderItems)
          ? data.purchaseOrderItems
          : Array.isArray(data.PurchaseOrderItems)
          ? data.PurchaseOrderItems
          : [];
        const items = rawItems.map((it, idx) => ({
          ...it,
          id: it.id || this.GenerateGuid(),
          seqNo: it.seqNo ?? idx + 1,
          itemId: it.itemId ?? it.ItemId ?? null,
          qty: it.qty ?? it.Qty ?? 0,
          rate: it.rate ?? it.Rate ?? it.purchasePrice ?? 0,
          indentItemId: it.indentItemId ?? it.IndentItemId ?? null,
          warehouseId: it.warehouseId ?? it.WarehouseId ?? null,
          remarks: it.remarks ?? it.Remarks ?? "",
        }));

        // normalize payments
        const rawPayments = Array.isArray(data.produtPurchasePayments)
          ? data.produtPurchasePayments
          : Array.isArray(data.ProdutPurchasePayments)
          ? data.ProdutPurchasePayments
          : [];
        const payments = rawPayments.map((p) => ({
          ...p,
          id: p.id || this.GenerateGuid(),
        }));

        // normalize PO header fields
        const poNo = data.purchaseOrderNo ?? data.PurchaseOrderNo ?? "";
        const poPurchaseRequestId =
          data.purchaseRequestId ?? data.PurchaseRequestId ?? "";

        // Try to resolve selectedPurchaseRequestId
        let resolvedPrId = poPurchaseRequestId
          ? String(poPurchaseRequestId)
          : "";

        // If still empty, try to find by PO number in loaded purchaseRequests list
        if (!resolvedPrId && poNo && Array.isArray(purchaseRequests)) {
          const found = purchaseRequests.find(
            (pr) =>
              String(pr.purchaseOrderNo ?? pr.PurchaseOrderNo ?? "") ===
              String(poNo)
          );
          if (found) resolvedPrId = String(found.id);
        }

        // If still empty, attempt to find a PR containing any indentItemId from items
        if (!resolvedPrId) {
          const indentIds = items
            .map((it) => String(it.indentItemId))
            .filter((v) => v && v !== "null" && v !== "undefined");
          if (
            indentIds.length > 0 &&
            Array.isArray(purchaseRequests) &&
            purchaseRequests.length > 0
          ) {
            // fetch each PR's items and check for matches (serially or in parallel). Use parallel but tolerate failures.
            const checks = purchaseRequests.map((pr) =>
              fetch(
                `${process.env.REACT_APP_API}ProductPurchase/GetPurchaseRequestById/${pr.id}`
              )
                .then((r) => r.json())
                .then((prData) => {
                  const prItems = Array.isArray(prData.purchaseRequestItems)
                    ? prData.purchaseRequestItems
                    : Array.isArray(prData.PurchaseRequestItems)
                    ? prData.PurchaseRequestItems
                    : [];
                  const has = prItems.some((pi) =>
                    indentIds.includes(String(pi.id ?? pi.Id))
                  );
                  return has ? String(pr.id) : null;
                })
                .catch((err) => {
                  console.warn("PR items fetch failed for", pr.id, err);
                  return null;
                })
            );

            try {
              const results = await Promise.all(checks);
              const match = results.find((r) => r);
              if (match) resolvedPrId = match;
            } catch (e) {
              console.warn("parallel PR checks errored", e);
            }
          }
        }

        console.log(
          "GetPurchaseOrderById -> resolvedPrId:",
          resolvedPrId,
          "poNo:",
          poNo,
          "poPurchaseRequestId:",
          poPurchaseRequestId
        );

        // set state with normalized fields
        this.setState(
          {
            purchaseOrder: {
              ...this.state.purchaseOrder,
              ...data,
              purchaseOrderNo: poNo,
              purchaseRequestId: poPurchaseRequestId || resolvedPrId || "",
              invoiceDate: data.invoiceDate
                ? new Date(data.invoiceDate).toISOString().split("T")[0]
                : new Date().toISOString().split("T")[0],
            },
            PurchaseOrderItems: items,
            ProdutPurchasePayments: payments,
            selectedPurchaseRequestId:
              resolvedPrId || String(poPurchaseRequestId || "") || "",
          },
          () => {
            // finally populate loadedIndentItems for whichever PR id we settled on
            const usePrId =
              resolvedPrId ||
              (poPurchaseRequestId ? String(poPurchaseRequestId) : "");
            if (usePrId) {
              fetch(
                `${process.env.REACT_APP_API}ProductPurchase/GetPurchaseRequestById/${usePrId}`
              )
                .then((r) => r.json())
                .then((prData) => {
                  const prItems = Array.isArray(prData.purchaseRequestItems)
                    ? prData.purchaseRequestItems
                    : Array.isArray(prData.PurchaseRequestItems)
                    ? prData.PurchaseRequestItems
                    : [];
                  if (prItems.length > 0) {
                    this.setState({ loadedIndentItems: prItems });
                  } else {
                    // fallback: create indent list from PO rows so labels show
                    const fallback = items
                      .filter((it) => it.indentItemId)
                      .map((it) => ({
                        id: it.indentItemId,
                        itemName: it.itemName,
                        qty: it.qty,
                      }));
                    this.setState({ loadedIndentItems: fallback });
                  }
                })
                .catch((err) => {
                  console.warn(
                    "Could not load PR items for resolved PR:",
                    usePrId,
                    err
                  );
                  const fallback = items
                    .filter((it) => it.indentItemId)
                    .map((it) => ({
                      id: it.indentItemId,
                      itemName: it.itemName,
                      qty: it.qty,
                    }));
                  this.setState({ loadedIndentItems: fallback });
                });
            } else {
              const fallback = items
                .filter((it) => it.indentItemId)
                .map((it) => ({
                  id: it.indentItemId,
                  itemName: it.itemName,
                  qty: it.qty,
                }));
              this.setState({ loadedIndentItems: fallback });
            }
          }
        );
      })
      .catch((err) => {
        this.HideLoadSpinner();
        console.error("GetPurchaseOrderById error", err);
        Swal.fire("Error", "Failed to load Purchase Order.", "error");
      });
  };

  /* -------------------- Item modal handlers -------------------- */
  handleAddItems = () => this.setState({ showOrderItemModal: true });
  AddPurchaseItem = (item) => {
    this.setState((prev) => ({
      PurchaseOrderItems: [
        ...(prev.PurchaseOrderItems || []),
        { ...item, seqNo: (prev.PurchaseOrderItems || []).length + 1 },
      ],
      showOrderItemModal: false,
      editItemModalShow: false,
    }));
  };
  UpdatePurchaseItem = (item, index) => {
    const list = [...this.state.PurchaseOrderItems];
    const categoryName = item.categoryName || list[index]?.categoryName || "";
    list[index] = { ...list[index], ...item, categoryName };
    this.setState({ PurchaseOrderItems: list, editItemModalShow: false });
  };
  handleRemoveItem = (index) => {
    const it = this.state.PurchaseOrderItems[index];
    if (it?.addedToStock) {
      Swal.fire({
        title: "Warning!",
        text: "This item was already added to stock. Deleting will not update inventory automatically. Continue?",
        showCancelButton: true,
      }).then((res) => {
        if (res.isConfirmed) {
          const list = [...this.state.PurchaseOrderItems];
          list.splice(index, 1);
          this.setState({ PurchaseOrderItems: list });
        }
      });
    } else {
      const list = [...this.state.PurchaseOrderItems];
      list.splice(index, 1);
      this.setState({ PurchaseOrderItems: list });
    }
  };

  openEditItem = (index) =>
    this.setState({ editPurchaseItemRow: index, editItemModalShow: true });

  /* -------------------- Payment handlers -------------------- */
  OpenAddPayment = () => this.setState({ showPaymentModal: true });
  AddPurchasePayment = (payment) => {
    this.setState((prev) => ({
      ProdutPurchasePayments: [
        ...(prev.ProdutPurchasePayments || []),
        { ...payment, id: payment.id || this.GenerateGuid() },
      ],
      showPaymentModal: false,
      editPaymentModalShow: false,
    }));
  };
  UpdatePurchasePayment = (payment, index) => {
    const list = [...this.state.ProdutPurchasePayments];
    list[index] = { ...list[index], ...payment };
    this.setState({
      ProdutPurchasePayments: list,
      editPaymentModalShow: false,
    });
  };
  RemovePurchasePayment = (index) => {
    const list = [...this.state.ProdutPurchasePayments];
    list.splice(index, 1);
    this.setState({ ProdutPurchasePayments: list });
  };
  OnEditPaymentClick = (e, i) =>
    this.setState({ editPaymentRow: i, editPaymentModalShow: true });

  /* -------------------- Purchase Request load -------------------- */
  OnSelectPurchaseRequest = (e) => {
    const val = e.target.value;
    const selectedId = val ? String(val) : "";
    this.setState({ selectedPurchaseRequestId: selectedId });

    if (!selectedId) {
      this.setState((prev) => ({
        loadedIndentItems: [],
        purchaseOrder: {
          ...prev.purchaseOrder,
          purchaseRequestId: "",
          purchaseOrderNo: "",
        },
      }));
      return;
    }

    this.ShowLoadSpinner();
    fetch(
      `${process.env.REACT_APP_API}ProductPurchase/GetPurchaseRequestById/${selectedId}`
    )
      .then((r) => r.json())
      .then((data) => {
        this.HideLoadSpinner();
        if (!data) {
          Swal.fire("Error", "Could not load purchase request.", "error");
          return;
        }

        const prItems = Array.isArray(data.purchaseRequestItems)
          ? data.purchaseRequestItems
          : Array.isArray(data.PurchaseRequestItems)
          ? data.PurchaseRequestItems
          : [];

        const mapped = prItems.map((it, idx) => ({
          id: this.GenerateGuid(),
          seqNo: idx + 1,
          itemId: it.itemId || null,
          itemName: it.itemName || "",
          qty: it.qty || 0,
          unit: it.unit || "",
          rate: it.purchasePrice || 0,
          discount: 0,
          tax: 0,
          batchId: it.batchId || "",
          hsnCode: it.hsnCode || "",
          internalId: it.internalId || "",
          remarks: it.notes || "",
          thickness: it.thickness || 0,
          width: it.width || 0,
          length: it.length || 0,
          pieces: it.pieces || 0,
          localWt: it.localWt || it.weight || 0,
          warehouseId: it.warehouseId || null,
          addedToStock: false,
          indentItemId: it.id || it.Id || null,
          categoryId: it.categoryId || null,
          categoryName: it.categoryName || it.CategoryName || "",
        }));

        this.setState((prev) => {
          const existingIndentIds = new Set(
            (prev.PurchaseOrderItems || [])
              .map((r) => (r.indentItemId ? String(r.indentItemId) : null))
              .filter(Boolean)
          );
          const toAdd = mapped.filter(
            (m) =>
              m.indentItemId && !existingIndentIds.has(String(m.indentItemId))
          );
          const nextSeqBase = (prev.PurchaseOrderItems || []).length;
          const withSeq = toAdd.map((m, i) => ({
            ...m,
            seqNo: nextSeqBase + i + 1,
          }));

          return {
            loadedIndentItems: prItems,
            PurchaseOrderItems: [
              ...(prev.PurchaseOrderItems || []),
              ...withSeq,
            ],
            purchaseOrder: {
              ...prev.purchaseOrder,
              purchaseRequestId: data.id || data.Id || selectedId,
              purchaseOrderNo:
                data.purchaseOrderNo ||
                data.PurchaseOrderNo ||
                prev.purchaseOrder.purchaseOrderNo ||
                "",
            },
          };
        });
      })
      .catch((err) => {
        this.HideLoadSpinner();
        console.error("OnSelectPurchaseRequest error", err);
        Swal.fire("Error", "Failed to load purchase request items.", "error");
      });
  };

  /* -------------------- Totals / Calculations -------------------- */
  GetTotalOfPurchaseOrderWithoutTax = (items) =>
    (items || []).reduce(
      (sum, v) => sum + this.asNumber(v.rate) * this.asNumber(v.qty),
      0
    );

  GetTotalOfPurchaseOrderTaxAmount = (items) =>
    (items || []).reduce(
      (sum, v) =>
        sum +
        (this.asNumber(v.rate) * this.asNumber(v.qty) * this.asNumber(v.tax)) /
          100,
      0
    );

  // fallback if context doesn't provide ReturnwithTax
  GetTotalOfPurchaseOrder = (items) =>
    (items || []).reduce((sum, v) => {
      if (this.context && typeof this.context.ReturnwithTax === "function") {
        return (
          sum +
          this.context.ReturnwithTax(
            this.asNumber(v.rate),
            this.asNumber(v.qty),
            this.asNumber(v.discount),
            this.asNumber(v.tax)
          )
        );
      }
      const amountBeforeDiscount = this.asNumber(v.rate) * this.asNumber(v.qty);
      const afterDiscount =
        amountBeforeDiscount -
        (amountBeforeDiscount * this.asNumber(v.discount)) / 100;
      const taxAmount = (afterDiscount * this.asNumber(v.tax)) / 100;
      return sum + afterDiscount + taxAmount;
    }, 0);

  GetPurchaseLevelTaxAmount = (items) => {
    const subtotal = this.GetTotalOfPurchaseOrderWithoutTax(items);
    const po = this.state.purchaseOrder || {};
    const pct = this.asNumber(po.taxPercentage);
    if (!pct) return 0;
    return (this.asNumber(subtotal) * pct) / 100;
  };

  GetGrandTotal = (items) => {
    const subtotal = this.GetTotalOfPurchaseOrderWithoutTax(items);
    const itemTax = this.GetTotalOfPurchaseOrderTaxAmount(items);
    const purchaseTax = this.GetPurchaseLevelTaxAmount(items);
    const po = this.state.purchaseOrder || {};
    const loading = this.asNumber(po.loadingCharges);
    const transport = this.asNumber(po.transportationCharges);
    return (
      this.asNumber(subtotal) +
      this.asNumber(itemTax) +
      this.asNumber(purchaseTax) +
      this.asNumber(loading) +
      this.asNumber(transport)
    );
  };

  GetTotalPaid = () =>
    (this.state.ProdutPurchasePayments || []).reduce(
      (s, p) => s + this.asNumber(p.amount),
      0
    );

  GetIndentRefLabel = (indentOrId) => {
    if (!indentOrId) return "";
    const loaded = (this.state.loadedIndentItems || []).find(
      (r) => String(r.id) === String(indentOrId.id || indentOrId)
    );
    const selectedPR = (this.state.purchaseRequests || []).find(
      (pr) => String(pr.id) === String(this.state.selectedPurchaseRequestId)
    );
    const name = loaded?.itemName || indentOrId.itemName || "";
    const qty = loaded?.qty ?? indentOrId.qty ?? "";
    const qtyStr =
      qty !== "" && qty !== null && !isNaN(Number(qty))
        ? ` x ${Number(qty)}`
        : "";
    const parts = [];
    if (name) parts.push(`${name}${qtyStr}`);
    return parts.join(" — ");
  };

  /* -------------------- Submit / API -------------------- */
  AddOrUpdatePurchaseOrderInDB = () => {
    const items = this.state.PurchaseOrderItems || [];
    if (items.length === 0) {
      Swal.fire({
        title: "Warning",
        text: "Please add Purchased items and try!",
        timer: 3000,
      });
      return;
    }

    // ensure each item has warehouse & category (if your app requires category; adjust as needed)
    const invalidRow = items.find(
      (it) => !it.warehouseId /*|| !it.categoryId*/
    );
    if (invalidRow) {
      Swal.fire({
        title: "Validation",
        text: "Each purchase item must have a valid Warehouse. Please correct item(s) and try again.",
        icon: "warning",
      });
      return;
    }

    // duplicate indent detection
    const indentIds = items
      .map((it) => it.indentItemId)
      .filter((id) => id && String(id).trim() !== "");
    const duplicates = indentIds.filter(
      (id, index) => indentIds.indexOf(id) !== index
    );
    if (duplicates.length > 0) {
      const dupCount = [...new Set(duplicates)].length;
      Swal.fire({
        title: "Duplicate Indent Ref Found",
        text: `You have used the same Indent Reference in ${dupCount} item(s). Each indent item can be used only once in a Purchase Order.`,
        icon: "warning",
      });
      return;
    }

    const expectedTotal = Math.round(this.GetGrandTotal(items), 0);
    const paymentsSum = (this.state.ProdutPurchasePayments || []).reduce(
      (s, p) => s + this.asNumber(p.amount),
      0
    );
    const TOL = 0.01;

    const po = this.state.purchaseOrder || {};

    if (Number(po.paymentStatusId) === 1) {
      // Paid
      if (
        Math.abs(this.asNumber(paymentsSum) - this.asNumber(expectedTotal)) >
        TOL
      ) {
        Swal.fire({
          title: "Warning",
          text: "Paid Amount is not correct!",
          timer: 3000,
        });
        return;
      }
    }
    if (Number(po.paymentStatusId) === 3) {
      if (this.asNumber(paymentsSum) >= this.asNumber(expectedTotal) - TOL) {
        Swal.fire({
          title: "Validation",
          text: "Status is 'Partially Paid' but payments equal or exceed total. Change status or correct payments.",
          icon: "warning",
        });
        return;
      }
    }

    this.ShowLoadSpinner();

    const payload = {
      ...po,
      created: po.created || undefined,
      invoiceDate: new Date(po.invoiceDate),
      purchaseOrderItems: items,
      produtPurchasePayments: this.state.ProdutPurchasePayments || [],
      paidAmount: paymentsSum,
      storeId: this.context.storeId,
      createdBy:
        this.context.userData?.emailId || this.context.userData?.email || "",
      purchaseOrderNo: po.purchaseOrderNo || "", // <-- ADD THIS LINE
      purchaseRequestId: po.purchaseRequestId || "", // <--- add this
    };

    fetch(
      `${process.env.REACT_APP_API}ProductPurchase/AddOrUpdatePurchaseOrder/`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      }
    )
      .then((res) => {
        this.HideLoadSpinner();
        if (res.status === 200) {
          this.props.onHide?.();
        } else if (res.status === 409) {
          Swal.fire(
            "Duplicate",
            "This Purchase Order already exists. Try again!",
            "error"
          );
        } else {
          Swal.fire("Error", `Server returned ${res.status}.`, "error");
        }
      })
      .catch((err) => {
        this.HideLoadSpinner();
        console.error("AddOrUpdatePurchaseOrder error", err);
        Swal.fire("Exception", "Try after sometime!\n" + err, "error");
      });
  };

  GetWarehouseName = (id) => {
    const wh = (this.props.warehouse || []).find(
      (w) => String(w.id) === String(id)
    );
    return wh ? wh.name : "";
  };

  handleSubmit = (e) => {
    e.preventDefault();
    e.stopPropagation();
    this.AddOrUpdatePurchaseOrderInDB();
  };

  /* -------------------- Attachment helpers -------------------- */
  // Called by child table (file input) - upload flow is implemented in table; this component keeps API name available
  UpdateAttachmentFileName = (id, filename) => {
    // minimal payload update
    return fetch(
      `${process.env.REACT_APP_API}ProductPurchase/UpdateProductPurchaseAttachmentFileName/`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id, attachmentFileName: filename }),
      }
    ).then((r) => r.ok);
  };

  GetTotalTaxAmount = (items) => {
    return this.GetTotalOfPurchaseOrderTaxAmount(items);
  };

  /* -------------------- Render -------------------- */
  render() {
    const items = this.state.PurchaseOrderItems || [];
    const po = this.state.purchaseOrder || {};

    return (
      <div className="container">
        <Modal
          {...this.props}
          aria-labelledby="contained-modal-title-vcenter"
          centered
          fullscreen="sm-down"
          backdrop="static"
          keyboard={false}
          dialogClassName="purchaseorder-modal"
          scrollable
        >
          {this.state.msgboxOpen && (
            <MessageBox
              open={this.state.msgboxOpen}
              title={this.state.msgboxTitle}
              message={this.state.msgboxMessage}
              callback={this.CloseMessagBoxCallback}
            />
          )}
          {this.state.loadSpinnerOpen && <LoadSpinner open />}

          <Form onSubmit={this.handleSubmit}>
            <Modal.Header closeButton className="bg-warning">
              <Modal.Title>
                {this.props.Type === "Edit"
                  ? "Edit Product(FG) Purchase Order"
                  : "Add Product(FG) Purchase Order"}
              </Modal.Title>
            </Modal.Header>

            <Modal.Body className="show-grid">
              {/* Item modals */}
              {this.state.showOrderItemModal && (
                <AddOrEditPurchaseOrderItem
                  onHide={() => this.setState({ showOrderItemModal: false })}
                  AddPurchaseItem={this.AddPurchaseItem}
                  Type="Add"
                  prods={this.props.prods}
                  GetProductsInventories={this.props.GetProductsInventories} // optional
                  warehouse={this.props.warehouse}
                  indentItems={this.state.loadedIndentItems}
                />
              )}

              {this.state.editItemModalShow && (
                <AddOrEditPurchaseOrderItem
                  onHide={() => this.setState({ editItemModalShow: false })}
                  UpdatePurchaseItem={this.UpdatePurchaseItem}
                  Type="Edit"
                  purchaseOrderItem={items[this.state.editPurchaseItemRow]}
                  Index={this.state.editPurchaseItemRow}
                  prods={this.props.prods}
                  GetProductsInventories={this.props.GetProductsInventories}
                  warehouse={this.props.warehouse}
                  indentItems={this.state.loadedIndentItems}
                />
              )}

              {/* Payment modals */}
              {this.state.showPaymentModal && (
                <AddOrEditProductPurchasePayment
                  onHide={() => this.setState({ showPaymentModal: false })}
                  Type="Add"
                  AddPurchasePayment={this.AddPurchasePayment}
                />
              )}
              {this.state.editPaymentModalShow && (
                <AddOrEditProductPurchasePayment
                  onHide={() => this.setState({ editPaymentModalShow: false })}
                  Type="Edit"
                  payment={
                    this.state.ProdutPurchasePayments[this.state.editPaymentRow]
                  }
                  index={this.state.editPaymentRow}
                  UpdatePurchasePayment={this.UpdatePurchasePayment}
                />
              )}

              {/* Header fields */}
              <div className="p-1 bg-light border-0 rounded-3">
                <Row className="p-0" style={{ fontSize: "12pt" }}>
                  <Col md={2}>
                    <FloatingLabel label="Invoice Number*" className="mb-3">
                      <Form.Control
                        type="text"
                        name="invoiceNo"
                        value={po.invoiceNo || ""}
                        required
                        onChange={(e) =>
                          this.setState({
                            purchaseOrder: { ...po, invoiceNo: e.target.value },
                          })
                        }
                      />
                    </FloatingLabel>
                  </Col>
                  <Col md={2}>
                    <FloatingLabel label="Invoice Date *" className="mb-3">
                      <Form.Control
                        type="date"
                        name="invoiceDate"
                        value={
                          po.invoiceDate
                            ? new Date(po.invoiceDate)
                                .toISOString()
                                .split("T")[0]
                            : ""
                        }
                        required
                        onChange={(e) =>
                          this.setState({
                            purchaseOrder: {
                              ...po,
                              invoiceDate: e.target.value,
                            },
                          })
                        }
                      />
                    </FloatingLabel>
                  </Col>

                  <Col md={3}>
                    <FloatingLabel
                      label="Load from PO Number(indent)"
                      className="mb-3"
                    >
                      <Form.Select
                        name="purchaseRequestSelect"
                        value={this.state.selectedPurchaseRequestId || ""}
                        onChange={this.OnSelectPurchaseRequest}
                      >
                        <option value="">-- Select PO Indent --</option>
                        {(this.state.purchaseRequests || []).map((pr) => (
                          <option key={pr.id} value={String(pr.id)}>
                            {pr.purchaseOrderNo || String(pr.id)}
                          </option>
                        ))}
                      </Form.Select>
                    </FloatingLabel>
                  </Col>

                  <Col md={2}>
                    <FloatingLabel label="Supplier*" className="mb-3">
                      <Form.Select
                        name="supplierId"
                        value={po.supplierId || ""}
                        required
                        onChange={(e) =>
                          this.setState({
                            purchaseOrder: {
                              ...po,
                              supplierId: e.target.value,
                            },
                          })
                        }
                      >
                        <option value=""></option>
                        {(this.props.suppliers || []).map((s) => (
                          <option key={s.id} value={s.id}>
                            {s.name}
                          </option>
                        ))}
                      </Form.Select>
                    </FloatingLabel>
                  </Col>

                  <Col md={2}>
                    <FloatingLabel label="Payment Status*" className="mb-3">
                      <Form.Select
                        name="paymentStatusId"
                        value={po.paymentStatusId || ""}
                        required
                        onChange={(e) =>
                          this.setState({
                            purchaseOrder: {
                              ...po,
                              paymentStatusId: e.target.value,
                            },
                          })
                        }
                      >
                        <option value=""></option>
                        <option value={1}>Paid</option>
                        <option value={2}>Unpaid</option>
                        <option value={3}>PartiallyPaid</option>
                      </Form.Select>
                    </FloatingLabel>
                  </Col>
                </Row>

                <Row>
                  <Col md={12}>
                    <FloatingLabel label="Notes" className="mb-3">
                      <Form.Control
                        type="text"
                        name="description"
                        value={po.description || ""}
                        onChange={(e) =>
                          this.setState({
                            purchaseOrder: {
                              ...po,
                              description: e.target.value,
                            },
                          })
                        }
                      />
                    </FloatingLabel>
                  </Col>
                </Row>
              </div>

              {/* Items table */}
              <div className="my-3 bg-light rounded-3">
                <Row>
                  <Col md={8} className="text-start text-dark my-2">
                    <h4> Purchase Items: </h4>
                  </Col>
                  <Col md={4} className="text-end align-bottom my-2">
                    <Button
                      variant="primary"
                      size="sm"
                      onClick={this.handleAddItems}
                    >
                      + Add (F8)
                    </Button>
                  </Col>
                </Row>

                <div className="p-3 border d-none d-md-block">
                  <Table
                    bordered
                    hover
                    striped
                    className="text-start"
                    style={{ fontSize: "12px" }}
                  >
                    <thead className="bg-secondary text-white">
                      {this.context.store.businessTypeId ===
                      this.context.BusinessTypes.STEELTRADERS ? (
                        <>
                          <tr className="text-center">
                            <td>#</td>
                            <td className="text-start">Product Name</td>
                            <td>Thickness</td>
                            <td>Width</td>
                            <td>Length</td>
                            <td>BatchId</td>
                            <td>InternalId</td>
                            <td>HSNCode</td>
                            <td>Remarks</td>
                            <td>Pieces</td>
                            <td>Purchased Qty/Wt</td>
                            <td>LocalWt</td>
                            <td>Purchase Rate/Unit</td>
                            <td>Tax %</td>
                            <td>Unit</td>
                            <td>S.Total</td>
                            <td>Tax Value</td>
                            <td>Total Value</td>
                            <td>Indent Ref</td>
                            {/* <td>Category</td> */}
                            <td>WH</td>
                            <td>Added to Inventory?</td>
                            <td>Options</td>
                          </tr>
                        </>
                      ) : (
                        <>
                          <tr className="text-center">
                            <td>#</td>
                            <td className="text-start">Product Name</td>
                            <td>BatchId</td>
                            <td>HSNCode</td>
                            <td>Purchased Qty/Wt</td>
                            <td>Purchase Rate/Unit</td>
                            <td>Tax %</td>
                            <td>Unit</td>
                            {/* <td>S.Total</td> */}
                            <td>S.Total Purchase Amt(A)</td>
                            <td>S.Total Tax Amount(B)</td>
                            <td>A+B</td>

                            <td>MRP/Unit</td>
                            <td>Indent Ref</td>
                            {/* <td>Category</td> */}
                            <td>WH</td>
                            <td>Added to Inventory?</td>
                            <td>Options</td>
                          </tr>
                        </>
                      )}
                    </thead>
                    <tbody>
                      {items.map((row, i) => {
                        const rate = this.asNumber(row.rate);
                        const qty = this.asNumber(row.qty);
                        const subtotal = rate * qty;
                        return (
                          <tr
                            key={row.id || i}
                            className="align-middle text-center"
                          >
                            {this.context.store.businessTypeId ===
                            this.context.BusinessTypes.STEELTRADERS ? (
                              <>
                                <td>{i + 1}</td>
                                <td className="text-start">
                                  <b>{row.itemName}</b>
                                </td>
                                <td>{row.thickness || ""}</td>
                                <td>{row.width || ""}</td>
                                <td>{row.length || ""}</td>
                                <td>{row.batchId || ""}</td>
                                <td>{row.internalId || ""}</td>
                                <td>{row.hsnCode || ""}</td>
                                <td>{row.remarks || ""}</td>
                                <td>{row.pieces || ""}</td>
                                <td>{row.qty}</td>
                                <td>{row.localWt || ""}</td>
                                <td>
                                  {this.asNumber(row.rate).toLocaleString(
                                    this.context.storeSettings?.defaultLocale ||
                                      "en-IN",
                                    {
                                      minimumFractionDigits: 0,
                                      maximumFractionDigits: 1,
                                      style: "currency",
                                      currency:
                                        this.context.storeSettings
                                          ?.defaultCurrency || "INR",
                                    }
                                  )}
                                </td>
                                <td>{row.unit || ""}</td>
                                <td className="text-end">
                                  {(this.context.ReturnwithDiscount
                                    ? this.context.ReturnwithDiscount(
                                        this.asNumber(row.rate),
                                        this.asNumber(row.qty),
                                        this.asNumber(row.discount)
                                      )
                                    : this.asNumber(row.rate) *
                                        this.asNumber(row.qty) -
                                      (this.asNumber(row.rate) *
                                        this.asNumber(row.qty) *
                                        this.asNumber(row.discount)) /
                                        100
                                  ).toLocaleString(
                                    this.context.storeSettings?.defaultLocale ||
                                      "en-IN",
                                    {
                                      minimumFractionDigits: 0,
                                      maximumFractionDigits: 0,
                                      style: "currency",
                                      currency:
                                        this.context.storeSettings
                                          ?.defaultCurrency || "INR",
                                    }
                                  )}
                                </td>
                                <td>
                                  {this.GetIndentRefLabel(
                                    row.indentItemId || ""
                                  )}
                                </td>
                                {/* <td>
                                  {row.categoryName || row.categoryId || ""}
                                </td> */}
                                <td className="text-center">
                                  {this.GetWarehouseName(row.warehouseId)}
                                </td>
                              </>
                            ) : (
                              <>
                                <td>{i + 1}</td>
                                <td className="text-start">
                                  <b>{row.itemName}</b>
                                </td>
                                <td>{row.batchId || ""}</td>

                                <td>{row.hsnCode || ""}</td>

                                <td>{row.qty}</td>

                                <td>
                                  {this.asNumber(row.rate).toLocaleString(
                                    this.context.storeSettings?.defaultLocale ||
                                      "en-IN",
                                    {
                                      minimumFractionDigits: 0,
                                      maximumFractionDigits: 1,
                                      style: "currency",
                                      currency:
                                        this.context.storeSettings
                                          ?.defaultCurrency || "INR",
                                    }
                                  )}
                                </td>
                                <td>{row.tax || ""}</td>
                                <td>{row.unit || ""}</td>

                                <td>
                                  {this.context
                                    .ReturnwithDiscount(
                                      this.asNumber(row.rate),
                                      this.asNumber(row.qty),
                                      this.asNumber(row.discount)
                                    )
                                    .toLocaleString(
                                      this.context.storeSettings
                                        ?.defaultLocale || "en-IN",
                                      {
                                        minimumFractionDigits: 0,
                                        maximumFractionDigits: 1,
                                        style: "currency",
                                        currency:
                                          this.context.storeSettings
                                            ?.defaultCurrency || "INR",
                                      }
                                    )}
                                </td>
                                <td>
                                  {(
                                    (this.context.ReturnwithDiscount(
                                      this.asNumber(row.rate),
                                      this.asNumber(row.qty),
                                      this.asNumber(row.discount)
                                    ) *
                                      this.asNumber(row.tax)) /
                                    100
                                  ).toLocaleString(
                                    this.context.storeSettings?.defaultLocale ||
                                      "en-IN",
                                    {
                                      minimumFractionDigits: 0,
                                      maximumFractionDigits: 1,
                                      style: "currency",
                                      currency:
                                        this.context.storeSettings
                                          ?.defaultCurrency || "INR",
                                    }
                                  )}
                                </td>
                                <td>
                                  {(
                                    this.context.ReturnwithDiscount(
                                      this.asNumber(row.rate),
                                      this.asNumber(row.qty),
                                      this.asNumber(row.discount)
                                    ) +
                                    (this.context.ReturnwithDiscount(
                                      this.asNumber(row.rate),
                                      this.asNumber(row.qty),
                                      this.asNumber(row.discount)
                                    ) *
                                      this.asNumber(row.tax)) /
                                      100
                                  ).toLocaleString(
                                    this.context.storeSettings?.defaultLocale ||
                                      "en-IN",
                                    {
                                      minimumFractionDigits: 0,
                                      maximumFractionDigits: 1,
                                      style: "currency",
                                      currency:
                                        this.context.storeSettings
                                          ?.defaultCurrency || "INR",
                                    }
                                  )}
                                </td>

                                <td>{row.mrp}</td>
                                <td>
                                  {this.GetIndentRefLabel(
                                    row.indentItemId || ""
                                  )}
                                </td>
                                {/* <td>
                                  {row.categoryName || row.categoryId || ""}
                                </td> */}
                                <td className="text-center">
                                  {this.GetWarehouseName(row.warehouseId)}
                                </td>
                              </>
                            )}

                            <td>
                              {row.addedToStock ? (
                                <span className="bg-success text-white p-1">
                                  Added
                                </span>
                              ) : (
                                <span className="bg-warning text-dark p-1">
                                  Not Added
                                </span>
                              )}
                            </td>
                            <td className="text-center">
                              <Stack direction="horizontal" gap={2}>
                                <OverlayTrigger
                                  overlay={<Tooltip>Edit</Tooltip>}
                                >
                                  <Button
                                    size="sm"
                                    variant="primary"
                                    onClick={() => this.openEditItem(i)}
                                  >
                                    Open
                                  </Button>
                                </OverlayTrigger>
                                <OverlayTrigger
                                  overlay={<Tooltip>Delete</Tooltip>}
                                >
                                  <Button
                                    size="sm"
                                    variant="danger"
                                    onClick={() => this.handleRemoveItem(i)}
                                  >
                                    X
                                  </Button>
                                </OverlayTrigger>
                              </Stack>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </Table>
                </div>

                {/* Totals table */}
                <div className="p-3 border">
                  <Table>
                    <tbody>
                      <tr>
                        <td colSpan={8}></td>
                        <td colSpan={3} className="text-end align-middle">
                          <label className="mb-0 me-2 muted-small">
                            Total (without tax):
                          </label>
                        </td>
                        <td colSpan={3} className="text-end">
                          <h4 className="mb-0">
                            {items.length > 0
                              ? this.asNumber(
                                  this.GetTotalOfPurchaseOrderWithoutTax(items)
                                ).toLocaleString(
                                  this.context.storeSettings?.defaultLocale ||
                                    "en-IN",
                                  {
                                    style: "currency",
                                    currency:
                                      this.context.storeSettings
                                        ?.defaultCurrency || "INR",
                                    minimumFractionDigits: 1,
                                    maximumFractionDigits: 1,
                                  }
                                )
                              : ""}
                          </h4>
                        </td>
                      </tr>

                      {/* <tr>
                        <td colSpan={8}></td>
                        <td colSpan={3} className="text-end align-middle">
                          <div className="d-flex justify-content-end gap-2 align-items-center">
                            <label className="mb-0 me-2 muted-small">
                              Purchase Tax (%)
                            </label>
                            <input
                              type="number"
                              step="0.01"
                              min="0"
                              name="taxPercentage"
                              value={po.taxPercentage ?? ""}
                              onChange={(e) =>
                                this.setState({
                                  purchaseOrder: {
                                    ...po,
                                    taxPercentage: e.target.value,
                                  },
                                })
                              }
                              className="form-control form-control-sm"
                              style={{
                                width: "110px",
                                display: "inline-block",
                              }}
                            />
                          </div>
                        </td>
                        <td colSpan={3} className="text-end">
                          <strong>
                            {this.asNumber(
                              this.GetPurchaseLevelTaxAmount(items)
                            ).toLocaleString(
                              this.context.storeSettings?.defaultLocale ||
                                "en-IN",
                              {
                                style: "currency",
                                currency:
                                  this.context.storeSettings?.defaultCurrency ||
                                  "INR",
                                minimumFractionDigits: 1,
                                maximumFractionDigits: 1,
                              }
                            )}
                          </strong>
                        </td>
                      </tr> */}
                      <tr>
                        <td colSpan={8}></td>
                        <td colSpan={3} className="text-end align-middle">
                          <label className="mb-0 me-2 muted-small">
                            Total Tax Amount:
                          </label>
                        </td>
                        <td colSpan={3} className="text-end">
                          <strong>
                            {this.asNumber(
                              this.GetTotalTaxAmount(items)
                            ).toLocaleString(
                              this.context.storeSettings?.defaultLocale ||
                                "en-IN",
                              {
                                style: "currency",
                                currency:
                                  this.context.storeSettings?.defaultCurrency ||
                                  "INR",
                                minimumFractionDigits: 1,
                                maximumFractionDigits: 1,
                              }
                            )}
                          </strong>
                        </td>
                      </tr>

                      <tr>
                        <td colSpan={8}></td>
                        <td colSpan={3} className="text-end align-middle">
                          <div className="d-flex justify-content-end gap-2 align-items-center">
                            <label className="mb-0 me-2 muted-small">
                              Loading Charges
                            </label>
                            <input
                              type="number"
                              step="0.01"
                              min="0"
                              name="loadingCharges"
                              value={po.loadingCharges ?? ""}
                              onChange={(e) =>
                                this.setState({
                                  purchaseOrder: {
                                    ...po,
                                    loadingCharges: e.target.value,
                                  },
                                })
                              }
                              className="form-control form-control-sm"
                              style={{
                                width: "110px",
                                display: "inline-block",
                              }}
                            />
                          </div>
                        </td>
                        <td colSpan={3} className="text-end">
                          <strong>
                            {this.asNumber(
                              po.loadingCharges || 0
                            ).toLocaleString(
                              this.context.storeSettings?.defaultLocale ||
                                "en-IN",
                              {
                                style: "currency",
                                currency:
                                  this.context.storeSettings?.defaultCurrency ||
                                  "INR",
                                minimumFractionDigits: 1,
                                maximumFractionDigits: 1,
                              }
                            )}
                          </strong>
                        </td>
                      </tr>

                      <tr>
                        <td colSpan={8}></td>
                        <td colSpan={3} className="text-end align-middle">
                          <div className="d-flex justify-content-end gap-2 align-items-center">
                            <label className="mb-0 me-2 muted-small">
                              Transportation Charges
                            </label>
                            <input
                              type="number"
                              step="0.01"
                              min="0"
                              name="transportationCharges"
                              value={po.transportationCharges ?? ""}
                              onChange={(e) =>
                                this.setState({
                                  purchaseOrder: {
                                    ...po,
                                    transportationCharges: e.target.value,
                                  },
                                })
                              }
                              className="form-control form-control-sm"
                              style={{
                                width: "110px",
                                display: "inline-block",
                              }}
                            />
                          </div>
                        </td>
                        <td colSpan={3} className="text-end">
                          <strong>
                            {this.asNumber(
                              po.transportationCharges || 0
                            ).toLocaleString(
                              this.context.storeSettings?.defaultLocale ||
                                "en-IN",
                              {
                                style: "currency",
                                currency:
                                  this.context.storeSettings?.defaultCurrency ||
                                  "INR",
                                minimumFractionDigits: 1,
                                maximumFractionDigits: 1,
                              }
                            )}
                          </strong>
                        </td>
                      </tr>

                      <tr className="bg-light">
                        <td colSpan={10}></td>
                        <td colSpan={3} className="text-end">
                          <h5 className="mb-0">Grand Total</h5>
                        </td>
                        <td className="text-end">
                          <h5 className="mb-0">
                            {this.asNumber(
                              this.GetGrandTotal(items)
                            ).toLocaleString(
                              this.context.storeSettings?.defaultLocale ||
                                "en-IN",
                              {
                                style: "currency",
                                currency:
                                  this.context.storeSettings?.defaultCurrency ||
                                  "INR",
                                minimumFractionDigits: 0,
                                maximumFractionDigits: 0,
                              }
                            )}
                          </h5>
                        </td>
                      </tr>
                    </tbody>
                  </Table>
                </div>

                <Row className="text-end">
                  <h6 className="text-danger">
                    Information: while Save, Purchase Rate, MRP and In-stock
                    will be updated in "Product Inventory" accordingly!
                  </h6>
                </Row>
              </div>

              {/* Payments */}
              <div className="my-3 bg-light rounded-3">
                <Row>
                  <Col md={8} className="text-start text-dark my-2">
                    <h4>Payments:</h4>
                  </Col>
                  <Col md={4} className="text-end align-bottom my-2">
                    <Button
                      variant="primary"
                      size="sm"
                      onClick={this.OpenAddPayment}
                    >
                      + Add Payment
                    </Button>
                  </Col>
                </Row>

                <div className="p-3 border">
                  <Table
                    bordered
                    hover
                    striped
                    size="sm"
                    className="text-start"
                  >
                    <thead className="bg-secondary text-white">
                      <tr>
                        <th>Date</th>
                        <th>Method</th>
                        <th>Transaction ID</th>
                        <th>Amount</th>
                        <th>Notes</th>
                        <th width="10%">Options</th>
                      </tr>
                    </thead>
                    <tbody>
                      {(this.state.ProdutPurchasePayments || []).map(
                        (row, i) => (
                          <tr key={i}>
                            <td>
                              {row.paymentDate
                                ? new Date(row.paymentDate).toLocaleDateString(
                                    "en-IN"
                                  )
                                : ""}
                            </td>
                            <td>
                              {this.GetPaymentMethodName
                                ? this.GetPaymentMethodName(row.paymentMethod)
                                : row.paymentMethod}
                            </td>
                            <td>{row.paymentTransactionId}</td>
                            <td className="text-end">
                              {this.asNumber(row.amount).toLocaleString(
                                "en-IN",
                                {
                                  style: "currency",
                                  currency:
                                    this.context.storeSettings
                                      ?.defaultCurrency || "INR",
                                }
                              )}
                            </td>
                            <td>{row.notes}</td>
                            <td className="text-center">
                              <Stack direction="horizontal" gap={2}>
                                <Button
                                  size="sm"
                                  variant="warning"
                                  onClick={(e) => this.OnEditPaymentClick(e, i)}
                                >
                                  Edit
                                </Button>
                                <Button
                                  size="sm"
                                  variant="danger"
                                  onClick={() => this.RemovePurchasePayment(i)}
                                >
                                  Delete
                                </Button>
                              </Stack>
                            </td>
                          </tr>
                        )
                      )}
                    </tbody>
                  </Table>
                </div>
              </div>
            </Modal.Body>

            <Modal.Footer className="bg-light">
              <Form.Group>
                <Button variant="primary" size="lg" type="submit">
                  Save
                </Button>
              </Form.Group>
              <Button variant="danger" size="lg" onClick={this.props.onHide}>
                Close
              </Button>
            </Modal.Footer>
          </Form>
        </Modal>
      </div>
    );
  }

  // Payment method name helper (same as rawmaterial)
  GetPaymentMethodName(method) {
    const m = Number(method);
    switch (m) {
      case 1:
        return "Cash";
      case 2:
        return "Bank Transfer";
      case 3:
        return "Cheque";
      case 4:
        return "UPI";
      case 5:
        return "Razorpay";
      default:
        return method ? String(method) : "Other";
    }
  }
}

export class AddOrEditPurchaseOrderItem extends Component {
  static contextType = CartContext;

  constructor(props) {
    super(props);
    this.state = {
      sku: "",
      itemId: "",
      itemName: "",
      unit: "",
      discount: 0,
      tax: 0,
      // initialize warehouseId prefer edit item then props.warehouseId
      warehouseId:
        (props.purchaseOrderItem && props.purchaseOrderItem.warehouseId) ||
        props.warehouseId ||
        "",
      pieces: 1,
      hsnCode: "",
      batchId: "",
      remarks: "",
      qty: 1,
      rate: 0,
      localWt: undefined,
      mrp: undefined,
      productNames: [],
      prods: [],
      addedToStock: false,
      indentItemId: "",

      // inventory creation fields (if creating new product inline)
      categoryId: "", // this maps to sub-category (actual category stored on product)
      subCategoryId: "",
      mainCategoryId: "",
      internalId: "",
      instock: 0,
      pieceCount: 0,
      thickness: 0,
      width: 0,
      length: 0,
      qualityId: "",

      categories: [],

      isExisting: false,
    };

    this.asNumber = this.asNumber.bind(this);
  }

  asNumber(v) {
    if (v === null || v === undefined || v === "") return 0;
    const n = Number(v);
    return Number.isNaN(n) ? 0 : n;
  }

  componentDidMount() {
    // If editing, copy fields from purchaseOrderItem
    if (this.props.Type === "Edit" && this.props.purchaseOrderItem) {
      const pi = this.props.purchaseOrderItem;
      // derive mainCategoryId if only categoryId (sub) provided
      let mainCat = pi.mainCategoryId || "";
      if (
        !mainCat &&
        pi.categoryId &&
        Array.isArray(this.context.subCategories)
      ) {
        const sub = this.context.subCategories.find(
          (s) => String(s.id) === String(pi.categoryId)
        );
        if (sub) mainCat = sub.mainCategoryId || "";
      }

      this.setState(
        {
          sku: pi.sku,
          itemId: pi.itemId,
          itemName: pi.itemName,
          unit: pi.unit,
          rate: pi.rate,
          qty: pi.qty,
          localWt: pi.localWt,
          mrp: pi.mrp,
          discount: pi.discount,
          tax: pi.tax,
          pieces: pi.pieces,
          warehouseId: pi.warehouseId || this.state.warehouseId,
          hsnCode: pi.hsnCode,
          batchId: pi.batchId,
          qualityId: pi.qualityId || "",
          internalId: pi.internalId || "",
          remarks: pi.remarks,
          addedToStock: !!pi.addedToStock,
          indentItemId: pi.indentItemId || "",
          categoryId: pi.categoryId || "",
          subCategoryId: pi.subCategoryId || pi.categoryId || "",
          mainCategoryId: mainCat,
          instock: pi.instock || 0,
          pieceCount: pi.pieces || 0,
          thickness: pi.thickness || 0,
          width: pi.width || 0,
          length: pi.length || 0,
          isExisting:
            !!pi.itemId &&
            String(pi.itemId) !== "00000000-0000-0000-0000-000000000000",
        },
        () => {
          // after state set, load products for warehouse and categories
          if (this.state.warehouseId) this.LoadProductName();
          this.InitCategories();
        }
      );
    } else {
      // not editing: ensure we still initialize productNames/categories
      if (this.state.warehouseId) this.LoadProductName();
      this.InitCategories();
    }
  }

  /**
   * Initialize categories for the category <select>.
   * Order of preference:
   * 1. props.categories (parent supplied)
   * 2. derive from props.prods (unique category ids + names)
   * 3. fall back to context lists
   */
  InitCategories = () => {
    // 1) if parent provided categories, use them
    if (
      Array.isArray(this.props.categories) &&
      this.props.categories.length > 0
    ) {
      this.setState({ categories: this.props.categories });
      return;
    }

    // 2) derive categories from prods prop if present
    const prods = Array.isArray(this.props.prods) ? this.props.prods : [];
    const catMap = new Map();
    prods.forEach((p) => {
      const cid = p.categoryId || p.CategoryId || p.subCategoryId || null;
      const cname =
        p.categoryName || p.CategoryName || p.subCategoryName || null;
      if (cid) {
        if (!catMap.has(String(cid))) {
          catMap.set(String(cid), {
            id: cid,
            name: cname || `Category ${cid}`,
          });
        }
      }
    });
    if (catMap.size > 0) {
      const cats = Array.from(catMap.values());
      this.setState({ categories: cats });
      return;
    }

    // 3) fallback to context main/sub categories if available
    if (
      Array.isArray(this.context.subCategories) &&
      this.context.subCategories.length > 0
    ) {
      const subs = this.context.subCategories
        .filter(
          (s) =>
            String(s.mainCategoryId) === String(this.state.mainCategoryId) ||
            !this.state.mainCategoryId
        )
        .map((s) => ({ id: s.id, name: s.name }));
      if (subs.length > 0) {
        this.setState({ categories: subs });
        return;
      }
    }

    // final fallback: empty
    this.setState({ categories: [] });
  };

  GetProductLabel = (product) => {
    let result = product.name || "";
    if (product.batchId)
      result +=
        this.context.store.businessTypeId ===
        this.context.BusinessTypes.STEELTRADERS
          ? ` CoilId:${product.batchId}`
          : ` BatchId:${product.batchId}`;
    if (product.remarks) result += ` ${product.remarks}`;
    return result;
  };

  LoadProductName = () => {
    // build options filtered by warehouseId
    const whId = this.state.warehouseId;
    const prods = Array.isArray(this.context.prods) ? this.context.prods : [];
    const prodsForWh = prods.filter(
      (f) => String(f.warehouseId) === String(whId)
    );
    const pd = prodsForWh.map((r) => ({
      value: r.id,
      label: this.GetProductLabel(r),
    }));
    this.setState({
      prods: prodsForWh,
      productNames: pd.sort((a, b) =>
        a.label.toUpperCase() > b.label.toUpperCase() ? 1 : -1
      ),
    });
  };

  GetLabelOfProduct = (id) => {
    if (!id) return "";
    const norm = String(id).toLowerCase();

    const findIn = (list) =>
      (Array.isArray(list) ? list : []).find(
        (f) => String((f.id ?? f.Id ?? "").toString()).toLowerCase() === norm
      );

    const prod =
      findIn(this.state.prods) || // prefer loaded per-warehouse list
      findIn(this.context?.prods) ||
      findIn(this.props?.prods) ||
      null;

    if (!prod) return "";

    let result = prod.name || prod.Name || "";
    if (prod.batchId || prod.BatchId)
      result += ` ${prod.batchId || prod.BatchId}`;
    if (prod.remarks || prod.Remarks)
      result += ` ${prod.remarks || prod.Remarks}`;
    return result;
  };

  OnProductNameChange = (optionOrEvent) => {
    const selectedId = optionOrEvent?.value ?? optionOrEvent ?? "";
    if (!selectedId) {
      this.setState({ itemId: "", isExisting: false });
      return;
    }

    // find the product in loaded per-warehouse list first, else fallback
    const prod =
      (this.state.prods || []).find(
        (f) => String(f.id) === String(selectedId)
      ) ||
      (this.context?.prods || []).find(
        (f) => String(f.id) === String(selectedId)
      ) ||
      (this.props?.prods || []).find(
        (f) => String(f.id) === String(selectedId)
      );

    if (!prod) {
      // selection may be an id not in lists — still set itemId
      this.setState({ itemId: String(selectedId), isExisting: true });
      return;
    }

    // populate fields from product
    const mainCat =
      prod.mainCategoryId ||
      (Array.isArray(this.context.subCategories)
        ? this.context.subCategories.find(
            (s) =>
              String(s.id) === String(prod.categoryId || prod.subCategoryId)
          )?.mainCategoryId
        : "") ||
      this.state.mainCategoryId;

    const subCat =
      prod.subCategoryId || prod.categoryId || this.state.subCategoryId;

    this.setState({
      itemId: String(prod.id),
      itemName: prod.name || "",
      unit: prod.unit || "piece",
      rate: prod.purchasePrice ?? prod.rate ?? this.state.rate,
      categoryId:
        prod.categoryId || prod.subCategoryId || this.state.categoryId,
      subCategoryId: subCat || this.state.subCategoryId,
      mainCategoryId: mainCat || this.state.mainCategoryId,
      hsnCode: prod.hsncode,
      tax: prod.gst,
      batchId: prod.batchId || prod.BatchId || this.state.batchId,
      internalId: prod.internalId || prod.InternalId || this.state.internalId,
      qualityId: prod.qualityId || prod.QualityId || this.state.qualityId,
      remarks: prod.remarks || this.state.remarks,
      thickness: prod.thickness ?? prod.Thickness ?? this.state.thickness,
      width: prod.width ?? prod.Width ?? this.state.width,
      isExisting: true,
    });
  };

  GetProductName = (id) =>
    (this.props.prods || []).find((f) => String(f.id) === String(id))?.name ||
    "";
  GetUnitOfProduct = (id) =>
    (this.props.prods || []).find((f) => String(f.id) === String(id))?.unit ||
    "";
  GetPurchasePriceOfProductId = (id) =>
    (this.props.prods || []).find((f) => String(f.id) === String(id))
      ?.purchasePrice || 0;

  OnIndentRefChange = (e) => {
    const val = e.target.value || "";
    this.setState({ indentItemId: val });
  };

  handleItemsInputChange = (e) => {
    const { name, value } = e.target;
    const numericFields = [
      "discount",
      "tax",
      "qty",
      "rate",
      "pieces",
      "localWt",
      "instock",
      "pieceCount",
      "thickness",
      "width",
      "length",
    ];
    const v = numericFields.includes(name) ? value : value;

    if (name === "warehouseId") {
      // when warehouse changes: reload product dropdown and clear any selected product
      this.setState(
        { warehouseId: value, itemId: "", isExisting: false },
        () => {
          this.LoadProductName();
        }
      );
      return;
    }

    if (name === "itemName") {
      // typing a new name should clear selected itemId (so we create new inventory)
      this.setState({ itemName: v, itemId: "", isExisting: false });
      return;
    }

    if (name === "mainCategoryId") {
      // change of main category should clear sub category selection
      this.setState(
        { mainCategoryId: value, subCategoryId: "", categoryId: "" },
        () => {
          // refresh derived categories list
          this.InitCategories();
        }
      );
      return;
    }

    // subCategoryId change should also update categoryId used in payload
    if (name === "subCategoryId") {
      this.setState({ subCategoryId: value, categoryId: value });
      return;
    }

    this.setState({ [name]: v });
  };

  EnsureInventoryExists = async () => {
    // If user already selected an existing product, just return it.
    if (this.state.itemId) return Promise.resolve(String(this.state.itemId));

    const storeId = this.context?.storeId;
    const payload = {
      id: "00000000-0000-0000-0000-000000000000",
      name: (this.state.itemName || "").trim(),
      storeId: storeId,
      // MATCH YOUR EF MODEL: send subCategoryId (Product.SubCategoryId)
      subCategoryId: this.state.subCategoryId || null,
      // don't send mainCategoryId - Product table doesn't have it
      warehouseId: this.state.warehouseId || null,
      thickness: this.state.thickness || 0,
      width: this.state.width || 0,
      length: this.state.length || 0,
      remarks: this.state.remarks || "",
      internalId: this.state.internalId || "",
      batchId: this.state.batchId || "",
      hsnCode: this.state.hsnCode || "",
      productVariantType:
        this.context?.storeSettings?.defaultProductVariantType ?? 1,
      qualityId: this.state.qualityId || "",
      unit:
        this.state.unit || this.context.storeSettings?.defaultUnit || "piece",
      price: this.state.rate || 0,
    };

    const createUrl = `${process.env.REACT_APP_API}StoreManager/AddOrUpdateProduct/`;
    const productsListUrl = (sid) =>
      `${process.env.REACT_APP_API}StoreManager/GetProducts/${sid}`;

    // helper - GUID regex
    const guidRegex =
      /[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}/;

    // helper - try to extract an id from arbitrary response object or text
    const extractIdFrom = (obj, rawText, headers) => {
      if (!obj && !rawText && !headers) return null;

      // if obj is a string, look for GUID
      if (typeof obj === "string") {
        const m = obj.match(guidRegex);
        if (m) return m[0];
      }

      // common direct fields
      const tryKeys = (o, keys) => {
        if (!o || typeof o !== "object") return null;
        for (const k of keys) {
          if (o[k]) {
            if (typeof o[k] === "string") {
              const m = String(o[k]).match(guidRegex);
              if (m) return m[0];
              return String(o[k]);
            }
            if (typeof o[k] === "number") return String(o[k]);
            if (typeof o[k] === "object") {
              const nested = extractIdFrom(o[k], null, null);
              if (nested) return nested;
            }
          }
        }
        return null;
      };

      const commonKeys = [
        "id",
        "Id",
        "productId",
        "ProductId",
        "newId",
        "NewId",
        "result",
        "data",
        "value",
      ];

      // Try top-level keys
      const fromObj = tryKeys(obj, commonKeys);
      if (fromObj) return fromObj;

      // If nested result/data contain the id
      if (obj && typeof obj === "object") {
        if (obj.result) {
          const r = tryKeys(obj.result, commonKeys);
          if (r) return r;
        }
        if (obj.data) {
          const d = tryKeys(obj.data, commonKeys);
          if (d) return d;
        }
        // scan object's properties shallowly for GUID strings
        for (const k of Object.keys(obj)) {
          const v = obj[k];
          if (typeof v === "string") {
            const m = v.match(guidRegex);
            if (m) return m[0];
          } else if (typeof v === "object") {
            const nested = extractIdFrom(v, null, null);
            if (nested) return nested;
          }
        }
      }

      // check rawText for GUID
      if (rawText && typeof rawText === "string") {
        const m = rawText.match(guidRegex);
        if (m) return m[0];
      }

      // check Location header (some APIs return Location: /api/.../{id})
      try {
        const loc =
          headers && (headers.get("location") || headers.get("Location"));
        if (loc) {
          const m = String(loc).match(guidRegex);
          if (m) return m[0];
        }
      } catch (e) {
        // ignore header parse errors
      }

      return null;
    };

    // helper - find a product in array by internalId, batchId, exact name, contains
    const findMatchInList = (list = []) => {
      if (!Array.isArray(list) || list.length === 0) return null;

      const itemName = (this.state.itemName || "").toUpperCase();
      const batchId = (this.state.batchId || "").toUpperCase();

      return (
        list.find(
          (p) =>
            (p.name || "").toUpperCase() + (p.batchId || "").toUpperCase() ===
            itemName + batchId
        ) || null
      );
    };

    try {
      // 1) attempt to create product on server
      console.debug(
        "EnsureInventoryExists: POST to create product with payload:",
        payload
      );
      const createRes = await fetch(createUrl, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      const rawText = await createRes.text();
      let parsed = null;
      try {
        parsed = rawText ? JSON.parse(rawText) : null;
      } catch (e) {
        parsed = rawText || null;
      }

      // attempt extract id
      const idFromCreate = extractIdFrom(parsed, rawText, createRes.headers);

      if (createRes.ok && idFromCreate) {
        console.debug(
          "EnsureInventoryExists: created product id (from response):",
          idFromCreate
        );
        return String(idFromCreate);
      }

      // if server responded OK but no id in body, try local/remote lookup
      if (createRes.ok && !idFromCreate) {
        console.warn(
          "EnsureInventoryExists: create call returned OK but no id found in response body. Will attempt to find product by identifiers.",
          { responseBody: parsed }
        );

        // 1) try local props.prods
        const localMatch = findMatchInList(this.props.prods || []);
        if (localMatch && localMatch.id) {
          console.debug(
            "EnsureInventoryExists: matched product in local props.prods:",
            localMatch
          );
          return String(localMatch.id);
        }

        // 2) try fetching product list from server (best-effort)
        if (!storeId) {
          const err = new Error(
            "Create succeeded but no id returned and storeId missing; cannot fetch product list to resolve id."
          );
          err._debug = {
            createStatus: createRes.status,
            createBody: parsed,
            rawText,
          };
          throw err;
        }

        const listRes = await fetch(productsListUrl(storeId));
        if (!listRes.ok) {
          const serverMsg =
            (parsed &&
              (parsed.message ||
                parsed.Message ||
                parsed.error ||
                parsed.Error)) ||
            `Create succeeded but no id and unable to fetch product list (HTTP ${listRes.status}).`;
          const err = new Error(serverMsg);
          err._debug = {
            createStatus: createRes.status,
            createBody: parsed,
            rawText,
          };
          throw err;
        }

        const listJson = await listRes.json();
        const remoteMatch = findMatchInList(
          Array.isArray(listJson) ? listJson : []
        );
        if (remoteMatch && remoteMatch.id) {
          console.debug(
            "EnsureInventoryExists: matched product in remote product list:",
            remoteMatch
          );
          return String(remoteMatch.id);
        }

        // not found anywhere
        const err = new Error(
          "Create succeeded but server did not return created id and no matching product found in product list."
        );
        err._debug = {
          createStatus: createRes.status,
          createBody: parsed,
          rawText,
          fetchedProductsCount: Array.isArray(listJson)
            ? listJson.length
            : null,
        };
        throw err;
      }

      // create returned non-ok -> still try to find existing product (maybe unique violation)
      const serverMessage =
        (parsed &&
          (parsed.message || parsed.Message || parsed.error || parsed.Error)) ||
        (typeof parsed === "string" ? parsed : `HTTP ${createRes.status}`);
      console.warn(
        "EnsureInventoryExists: create call failed / non-OK. Server message:",
        serverMessage,
        { parsed }
      );

      // try local
      const localFallback = findMatchInList(this.props.prods || []);
      if (localFallback && localFallback.id) {
        console.debug(
          "EnsureInventoryExists: create failed but found product in local props.prods:",
          localFallback
        );
        return String(localFallback.id);
      }

      // try remote product list if storeId available
      if (storeId) {
        try {
          const listRes2 = await fetch(productsListUrl(storeId));
          if (listRes2.ok) {
            const listJson2 = await listRes2.json();
            const found2 = findMatchInList(
              Array.isArray(listJson2) ? listJson2 : []
            );
            if (found2 && found2.id) {
              console.debug(
                "EnsureInventoryExists: create failed but found product in remote list:",
                found2
              );
              return String(found2.id);
            }
          }
        } catch (e) {
          console.error(
            "EnsureInventoryExists: attempted remote fallback but failed to fetch products list",
            e
          );
        }
      }

      // give up and throw server message with debug info
      const finalErr = new Error(serverMessage);
      finalErr._debug = {
        createStatus: createRes.status,
        createBody: parsed,
        rawText,
      };
      throw finalErr;
    } catch (err) {
      // last-resort: try local name match again, then rethrow
      console.error("EnsureInventoryExists: fatal error", err);
      const fallbackLocal = (this.props.prods || []).find(
        (p) =>
          String(p.name || "")
            .trim()
            .toLowerCase() === (this.state.itemName || "").trim().toLowerCase()
      );
      if (fallbackLocal && fallbackLocal.id) {
        console.warn(
          "EnsureInventoryExists: final fallback - returning local matched id",
          fallbackLocal
        );
        return String(fallbackLocal.id);
      }
      // propagate error so caller shows message
      throw err;
    }
  };

  handleSubmit = (event) => {
    event.preventDefault();
    event.stopPropagation();

    if (!this.state.itemName && !this.state.itemId) {
      Swal.fire({
        title: "Warning",
        text: "Product Name is mandatory!",
        timer: 3000,
      });
      return;
    }
    if (!this.state.warehouseId) {
      Swal.fire({ title: "Warning", text: "Select Warehouse!", timer: 3000 });
      return;
    }

    //duplicate check scoped to the selected warehouse ===
    try {
      const nameToCheck = (this.state.itemName || "").trim().toLowerCase();
      const batchToCheck = (this.state.batchId || "").trim().toLowerCase();

      if (nameToCheck) {
        const currentId = this.state.itemId ? String(this.state.itemId) : null;
        const targetWh = String(this.state.warehouseId);

        const combined = [
          ...(Array.isArray(this.state.prods) ? this.state.prods : []),
        ];

        const duplicate = combined.find((p) => {
          if (!p) return false;

          // name required
          if (!p.name) return false;

          // warehouse must match
          if (!p.warehouseId || String(p.warehouseId) !== targetWh)
            return false;

          // skip the product being edited
          if (currentId && String(p.id) === currentId) return false;

          // match name (case-insensitive)
          const sameName = String(p.name).trim().toLowerCase() === nameToCheck;

          // match batchId (case-insensitive)
          const sameBatch =
            (p.batchId ? String(p.batchId).trim().toLowerCase() : "") ===
            batchToCheck;

          return sameName && sameBatch;
        });

        if (duplicate) {
          Swal.fire({
            title: "Duplicate Product",
            text: `A product named "${this.state.itemName}" with Batch "${this.state.batchId}" already exists in this warehouse.`,
            icon: "warning",
          });
          return;
        }
      }
    } catch (dupEx) {
      console.warn("Duplicate-check failed, allowing save. Error:", dupEx);
    }

    this.EnsureInventoryExists()
      .then((itemId) => {
        const payload = {
          sku: this.state.sku,
          itemId: itemId,
          itemName: this.state.itemName,
          unit: this.state.unit,
          rate: this.state.rate,
          qty: this.state.qty,
          localWt: this.state.localWt,
          mrp: this.state.mrp,
          discount: this.state.discount,
          tax: this.state.tax,
          warehouseId: this.state.warehouseId,
          hsnCode: this.state.hsnCode,
          batchId: this.state.batchId,
          pieces: this.state.pieces,
          remarks: this.state.remarks,
          indentItemId: this.state.indentItemId || null,
          // inventory-level fields
          subCategoryId: this.state.subCategoryId,
          productVariantType:
            this.context?.storeSettings?.defaultProductVariantType ?? 1,
          mainCategoryId: this.state.mainCategoryId || null,
          internalId: this.state.internalId || "",
          instock: this.state.instock || 0,
          thickness: this.state.thickness || 0,
          width: this.state.width || 0,
          length: this.state.length || 0,
          qualityId: this.state.qualityId || "",
        };

        if (this.props.Type === "Add") this.props.AddPurchaseItem?.(payload);
        else this.props.UpdatePurchaseItem?.(payload, this.props.Index);

        this.props.onHide?.();
      })
      .catch((err) => {
        console.error("EnsureInventoryExists error", err);
        Swal.fire(
          "Error",
          err?.message || "Failed to create product. Try again.",
          "error"
        );
      });
  };

  GetIndentRefLabel = (indent) => {
    if (!indent) return "";
    let obj = indent;
    if (typeof indent === "string" || typeof indent === "number") {
      const found = (this.props.indentItems || []).find(
        (it) => String(it.id) === String(indent)
      );
      if (found) obj = found;
      else return String(indent);
    }
    const name = obj.itemName || obj.ItemName || obj.name || "";
    const qtyRaw = obj.qty ?? obj.quantity ?? obj.Qty ?? "";
    const qty =
      qtyRaw !== "" && qtyRaw !== null && !isNaN(Number(qtyRaw))
        ? Number(qtyRaw)
        : "";
    const qtyStr = qty !== "" ? ` x ${qty}` : "";
    const poNo = this.props.purchaseOrderNo || "";
    const parts = [];
    if (poNo) parts.push(poNo);
    if (name) parts.push(`${name}${qtyStr}`);
    return parts.join(" — ");
  };

  render() {
    const indentItems = this.props.indentItems || [];
    const categories = this.state.categories || [];
    const isReadOnly = this.state.addedToStock === true;
    const isExisting = this.state.isExisting === true;

    // list of subcategories filtered by selected mainCategory
    const subCategories = Array.isArray(this.context.subCategories)
      ? this.context.subCategories.filter(
          (s) => String(s.mainCategoryId) === String(this.state.mainCategoryId)
        )
      : [];

    return (
      <div className="container ">
        <Modal
          {...this.props}
          size="xl"
          centered
          show
          backdrop="static"
          keyboard={false}
        >
          <Form onSubmit={this.handleSubmit}>
            <Modal.Header closeButton className="bg-warning">
              <Modal.Title>
                {this.props.Type === "Edit"
                  ? "Edit Purchase Item"
                  : "Add Purchase Item"}
              </Modal.Title>
            </Modal.Header>

            <Modal.Body>
              <Row className="mb-2">
                <Col md={6}>
                  <Form.Group>
                    <Form.Label>Warehouse *</Form.Label>
                    <Form.Select
                      name="warehouseId"
                      value={this.state.warehouseId || ""}
                      required
                      disabled={isReadOnly}
                      onChange={this.handleItemsInputChange}
                    >
                      <option value=""></option>
                      {(this.props.warehouse || []).map((m) => (
                        <option key={m.id} value={m.id}>
                          {m.name}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </Col>

                {this.props.indentItems.length > 0 ? (
                  <>
                    <Col md={6}>
                      <Form.Group>
                        <Form.Label>Indent Ref</Form.Label>
                        <Form.Select
                          name="indentItemId"
                          disabled={isReadOnly}
                          value={this.state.indentItemId || ""}
                          onChange={this.OnIndentRefChange}
                        >
                          <option value="">-- none --</option>

                          {this.state.indentItemId &&
                            !indentItems.find(
                              (it) =>
                                String(it.id) ===
                                String(this.state.indentItemId)
                            ) && (
                              <option value={this.state.indentItemId}>
                                {this.GetIndentRefLabel({
                                  id: this.state.indentItemId,
                                  itemName: this.state.itemName,
                                  qty: this.state.qty,
                                })}
                              </option>
                            )}

                          {indentItems.map((it) => (
                            <option key={it.id} value={it.id}>
                              {this.GetIndentRefLabel(it)}
                            </option>
                          ))}
                        </Form.Select>
                      </Form.Group>
                    </Col>
                  </>
                ) : (
                  <></>
                )}
              </Row>

              <Row className="mx-1 mb-2 p-2 border CornersRoundedSmall bg-light">
                <Col md={5}>
                  <Form.Group>
                    <Form.Label>Select existing Product</Form.Label>
                    <div style={{ display: "flex", gap: 8 }}>
                      <div style={{ flex: 1 }}>
                        <Select
                          name="itemId"
                          isDisabled={isReadOnly}
                          value={
                            this.state.itemId
                              ? this.state.productNames.find(
                                  (opt) =>
                                    String(opt.value) ===
                                    String(this.state.itemId)
                                ) || null
                              : null
                          }
                          onChange={this.OnProductNameChange}
                          options={this.state.productNames}
                          placeholder="Select existing product (or leave empty to create new)"
                        />
                        <div className="small text-muted mt-1">
                          Selecting an existing product auto-fills fields and
                          makes some fields read-only.
                        </div>
                      </div>
                    </div>
                  </Form.Group>
                </Col>

                <Col md={4}>
                  <Form.Group>
                    <Form.Label>
                      Or enter NEW Product name{" "}
                      <small className="text-muted">
                        (creates new inventory)
                      </small>
                    </Form.Label>
                    <Form.Control
                      name="itemName"
                      disabled={isReadOnly || isExisting}
                      value={this.state.itemName}
                      onChange={this.handleItemsInputChange}
                    />
                    <div className="small text-muted mt-1">
                      Type a new name to create a new inventory item. Choosing
                      an existing product disables this field.
                    </div>
                  </Form.Group>
                </Col>
                {this.context.store.businessTypeId ===
                this.context.BusinessTypes.STEELTRADERS ? (
                  <>
                    <Col md={1}>
                      <FloatingLabel label="Thickness" className="mb-1">
                        <Form.Control
                          type="number"
                          name="thickness"
                          value={this.state.thickness}
                          disabled={isReadOnly || isExisting}
                          onChange={this.handleItemsInputChange}
                        />
                      </FloatingLabel>
                    </Col>
                    <Col md={1}>
                      <FloatingLabel label="Width" className="mb-1">
                        <Form.Control
                          type="number"
                          name="width"
                          value={this.state.width}
                          disabled={isReadOnly || isExisting}
                          onChange={this.handleItemsInputChange}
                        />
                      </FloatingLabel>
                    </Col>
                    <Col md={1}>
                      <FloatingLabel label="Length" className="mb-1">
                        <Form.Control
                          type="number"
                          name="length"
                          value={this.state.length}
                          disabled={isReadOnly || isExisting}
                          onChange={this.handleItemsInputChange}
                        />
                      </FloatingLabel>
                    </Col>
                  </>
                ) : (
                  <></>
                )}
              </Row>

              {this.context.store.businessTypeId ===
              this.context.BusinessTypes.STEELTRADERS ? (
                <>
                  <Row>
                    <Col md={2}>
                      <FloatingLabel label="BatchId / CoilId" className="mb-1">
                        <Form.Control
                          name="batchId"
                          value={this.state.batchId}
                          disabled={isReadOnly || isExisting}
                          onChange={this.handleItemsInputChange}
                        />
                      </FloatingLabel>
                    </Col>

                    <Col md={2}>
                      <FloatingLabel label="InternalId" className="mb-1">
                        <Form.Control
                          name="internalId"
                          disabled={isReadOnly || isExisting}
                          value={this.state.internalId}
                          onChange={this.handleItemsInputChange}
                        />
                      </FloatingLabel>
                    </Col>

                    <Col md={2}>
                      <FloatingLabel label="HSN Code" className="mb-1">
                        <Form.Control
                          name="hsnCode"
                          value={this.state.hsnCode}
                          disabled={isReadOnly || isExisting}
                          onChange={this.handleItemsInputChange}
                        />
                      </FloatingLabel>
                    </Col>

                    <Col md={2}>
                      <FloatingLabel label="Quality Id" className="mb-1">
                        <Form.Control
                          name="qualityId"
                          value={this.state.qualityId}
                          disabled={isReadOnly || isExisting}
                          onChange={this.handleItemsInputChange}
                        />
                      </FloatingLabel>
                    </Col>
                  </Row>
                </>
              ) : (
                <>
                  <Row className="mb-2">
                    <Col md={2}>
                      <FloatingLabel label="BatchId" className="mb-1">
                        <Form.Control
                          name="batchId"
                          value={this.state.batchId}
                          disabled={isReadOnly || isExisting}
                          onChange={this.handleItemsInputChange}
                        />
                      </FloatingLabel>
                    </Col>

                    <Col md={2}>
                      <FloatingLabel label="HSN Code" className="mb-1">
                        <Form.Control
                          name="hsnCode"
                          value={this.state.hsnCode}
                          disabled={isReadOnly || isExisting}
                          onChange={this.handleItemsInputChange}
                        />
                      </FloatingLabel>
                    </Col>
                  </Row>
                </>
              )}

              {/* remaining rows: qty, rate, unit, remarks etc (unchanged) */}

              <Row className="mb-2">
                {this.context.store.businessTypeId ===
                this.context.BusinessTypes.STEELTRADERS ? (
                  <>
                    <Col md={2}>
                      <FloatingLabel label="Pieces" className="mb-1">
                        <Form.Control
                          type="number"
                          name="pieces"
                          disabled={isReadOnly}
                          value={this.state.pieces}
                          onChange={this.handleItemsInputChange}
                        />
                      </FloatingLabel>
                    </Col>
                  </>
                ) : (
                  <></>
                )}

                <Col md={2}>
                  <FloatingLabel label="Purchased Qty/Wt" className="mb-1">
                    <Form.Control
                      type="number"
                      name="qty"
                      value={this.state.qty}
                      disabled={isReadOnly}
                      onChange={this.handleItemsInputChange}
                    />
                  </FloatingLabel>
                </Col>

                {this.context.store.businessTypeId ===
                this.context.BusinessTypes.STEELTRADERS ? (
                  <>
                    <Col md={2}>
                      <FloatingLabel label="Local Wt" className="mb-1">
                        <Form.Control
                          type="number"
                          name="localWt"
                          value={this.state.localWt ?? ""}
                          disabled={isReadOnly}
                          onChange={this.handleItemsInputChange}
                        />
                      </FloatingLabel>
                    </Col>
                  </>
                ) : (
                  <></>
                )}

                <Col md={2}>
                  <FloatingLabel label="Unit" className="mb-1">
                    <Form.Select
                      name="unit"
                      required
                      value={this.state.unit || ""}
                      disabled={isReadOnly || isExisting}
                      onChange={this.handleItemsInputChange}
                    >
                      <option value=""></option>
                      <option value="piece">piece</option>
                      <option value="gram">gram</option>
                      <option value="kg">kg</option>
                      <option value="ton">ton</option>
                      <option value="ml">ml</option>
                      <option value="liter">liter</option>
                      <option value="meter">meter</option>
                    </Form.Select>
                  </FloatingLabel>
                </Col>

                <Col md={3}>
                  <FloatingLabel
                    label="Purchase Rate(without gst)"
                    className="mb-1"
                  >
                    <Form.Control
                      type="number"
                      name="rate"
                      value={this.state.rate}
                      disabled={isReadOnly}
                      onChange={this.handleItemsInputChange}
                    />
                  </FloatingLabel>
                </Col>
                <Col md={2}>
                  <FloatingLabel label="GST(%)" className="mb-1">
                    <Form.Control
                      type="number"
                      name="tax"
                      value={this.state.tax}
                      disabled={isReadOnly}
                      onChange={this.handleItemsInputChange}
                    />
                  </FloatingLabel>
                </Col>
                <Col md={2}>
                  <FloatingLabel label="MRP / Selling Price" className="mb-1">
                    <Form.Control
                      type="number"
                      name="mrp"
                      required
                      value={this.state.mrp ?? ""}
                      disabled={isReadOnly}
                      onChange={this.handleItemsInputChange}
                    />
                  </FloatingLabel>
                </Col>
              </Row>
              <Row>
                <Col md={4}>
                  <FloatingLabel label="Main Category" className="mb-1">
                    <Form.Select
                      name="mainCategoryId"
                      disabled={isReadOnly}
                      required
                      value={this.state.mainCategoryId || ""}
                      onChange={this.handleItemsInputChange}
                    >
                      <option value="">-- Select Main Category --</option>
                      {(this.context.mainCategories || []).map((cat) => (
                        <option key={cat.id} value={cat.id}>
                          {cat.name}
                        </option>
                      ))}
                    </Form.Select>
                  </FloatingLabel>
                </Col>

                <Col md={4}>
                  <FloatingLabel label="Sub Category" className="mb-1">
                    <Form.Select
                      name="subCategoryId"
                      required
                      disabled={isReadOnly}
                      value={this.state.subCategoryId || ""}
                      onChange={this.handleItemsInputChange}
                    >
                      <option value="">-- Select Sub Category --</option>
                      {subCategories.map((sub) => (
                        <option key={sub.id} value={sub.id}>
                          {sub.name}
                        </option>
                      ))}
                    </Form.Select>
                  </FloatingLabel>
                </Col>
              </Row>

              <Row>
                <Col md={12}>
                  <FloatingLabel label="Remarks" className="mb-1">
                    <Form.Control
                      name="remarks"
                      value={this.state.remarks}
                      disabled={isReadOnly || isExisting}
                      onChange={this.handleItemsInputChange}
                    />
                  </FloatingLabel>
                </Col>
              </Row>
            </Modal.Body>

            <Modal.Footer>
              <Button variant="primary" type="submit">
                Save
              </Button>
              <Button variant="danger" onClick={() => this.props.onHide?.()}>
                Close
              </Button>
            </Modal.Footer>
          </Form>
        </Modal>
      </div>
    );
  }
}

export class AddOrEditProductPurchasePayment extends Component {
  constructor(props) {
    super(props);
    this.state = {
      payment: {
        id: props.payment?.id || "",
        paymentDate: props.payment?.paymentDate
          ? new Date(props.payment.paymentDate).toISOString().split("T")[0]
          : new Date().toISOString().split("T")[0],
        paymentTransactionId: props.payment?.paymentTransactionId || "",
        paymentMethod: props.payment?.paymentMethod || 1,
        amount: props.payment?.amount || 0,
        notes: props.payment?.notes || "",
      },
    };
  }

  handleChange = (e) => {
    const { name, value } = e.target;
    this.setState((prev) => ({
      payment: { ...prev.payment, [name]: value },
    }));
  };

  handleSave = () => {
    const { Type, AddPurchasePayment, UpdatePurchasePayment, index } =
      this.props;
    const { payment } = this.state;

    if (!payment.amount || Number(payment.amount) <= 0) {
      Swal.fire("Validation", "Please enter a valid amount", "warning");
      return;
    }

    const payload = {
      ...payment,
      amount: Number(payment.amount),
      paymentDate: new Date(payment.paymentDate),
    };

    if (Type === "Edit") {
      UpdatePurchasePayment && UpdatePurchasePayment(payload, index);
    } else {
      AddPurchasePayment && AddPurchasePayment(payload);
    }
  };

  render() {
    const { onHide, Type } = this.props;
    const { payment } = this.state;
    return (
      <Modal show onHide={onHide} centered>
        <Modal.Header closeButton>
          <Modal.Title>
            {Type === "Edit" ? "Edit Payment" : "Add Payment"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group className="mb-2">
              <Form.Label>Payment Date</Form.Label>
              <Form.Control
                type="date"
                name="paymentDate"
                value={payment.paymentDate}
                onChange={this.handleChange}
              />
            </Form.Group>

            <Form.Group className="mb-2">
              <Form.Label>Method</Form.Label>
              <Form.Select
                name="paymentMethod"
                value={payment.paymentMethod}
                onChange={this.handleChange}
              >
                <option value={1}>Cash</option>
                <option value={2}>Bank Transfer</option>
                <option value={3}>Cheque</option>
                <option value={4}>UPI</option>
                <option value={5}>Razorpay</option>
                <option value={9}>Other</option>
              </Form.Select>
            </Form.Group>

            <Form.Group className="mb-2">
              <Form.Label>Transaction Id</Form.Label>
              <Form.Control
                name="paymentTransactionId"
                value={payment.paymentTransactionId}
                onChange={this.handleChange}
              />
            </Form.Group>

            <Form.Group className="mb-2">
              <Form.Label>Amount</Form.Label>
              <Form.Control
                type="number"
                min="0"
                step="0.01"
                name="amount"
                value={payment.amount}
                onChange={this.handleChange}
              />
            </Form.Group>

            <Form.Group className="mb-2">
              <Form.Label>Notes</Form.Label>
              <Form.Control
                as="textarea"
                rows={2}
                name="notes"
                value={payment.notes}
                onChange={this.handleChange}
              />
            </Form.Group>
          </Form>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={onHide}>
            Cancel
          </Button>
          <Button variant="primary" onClick={this.handleSave}>
            {Type === "Edit" ? "Update" : "Add"}
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}
